<template>
  <div class="pa-4">
    <!-- Loading central con efecto transparente y sombra (Consulta y Generación de PDF) -->
    <v-overlay
      v-if="loadingConsulta || loaderpdf"
      :value="loadingConsulta || loaderpdf"
      z-index="9999"
      opacity="0.4"
      class="consulta-overlay-container"
    >
      <div class="consulta-loader-card">
        <div class="consulta-loader-spinner-wrapper mb-4">
          <v-progress-circular
            indeterminate
            :color="loaderpdf ? '#e11d48' : '#2563eb'"
            :size="64"
            :width="5"
          ></v-progress-circular>
          <div class="consulta-loader-inner-icon">
            <v-icon :color="loaderpdf ? '#e11d48' : '#2563eb'" size="26">
              {{ loaderpdf ? "mdi-file-pdf-box" : "mdi-chart-box-outline" }}
            </v-icon>
          </div>
        </div>

        <div class="consulta-loader-title font-weight-bold">
          {{
            loaderpdf
              ? "Generando Reporte PDF"
              : "Procesando Reporte Consolidado"
          }}
        </div>
        <div class="consulta-loader-subtitle mt-1">
          {{
            loaderpdf
              ? loaderpdfMensaje || "Generando reporte PDF en segundo plano..."
              : "Procesando reporte consolidado. Por favor, espere unos minutos..."
          }}
        </div>

        <!-- Botón Cancelar sólo para generación de PDF -->
        <div v-if="loaderpdf" class="mt-4">
          <v-btn
            small
            depressed
            color="#fee2e2"
            class="text-caption font-weight-bold red--text text--darken-3 px-4 rounded-pill"
            @click="cerrarVisor"
          >
            <v-icon left x-small>mdi-close</v-icon>
            Cancelar&nbsp;&nbsp;&nbsp;
          </v-btn>
        </div>
      </div>
    </v-overlay>

    <v-btn @click="$router.back()" class="back-btn mb-4">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <v-col cols="12" class="pa-0">
      <v-row justify="center">
        <v-col cols="12" lg="12">
          <v-card class="modern-report-card elevation-2 mb-4">
            <!-- Header moderno con gradiente y botón de ayuda -->
            <div class="report-header-banner">
              <div class="d-flex align-center header-main-info">
                <div class="header-icon-box mr-3 flex-shrink-0">
                  <v-icon color="white">mdi-chart-box-outline</v-icon>
                </div>
                <div class="header-text-block">
                  <div
                    class="font-weight-bold white--text header-company-title"
                  >
                    Reporte Consolidado de Neumáticos
                  </div>
                  <div class="header-report-subtitle">
                    Análisis integral de rendimiento, rotación, presiones,
                    desgaste y gestión operativa de la flota
                  </div>
                </div>
              </div>

              <div class="header-help-btn ml-auto flex-shrink-0">
                <!-- Botón de ayuda -->
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-1 btn-circle-tooltip"
                      icon
                      dark
                      target="_blank"
                      :href="
                        global && global.helpdesk_url
                          ? global.helpdesk_url + 'reporte-generar-consolidado'
                          : '#'
                      "
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon size="22" color="amber lighten-2"
                        >mdi-help-circle-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>¿Necesitas ayuda?</span>
                </v-tooltip>
              </div>
            </div>

            <!-- Cuerpo del formulario y filtros -->
            <v-card-text class="pa-4 pa-md-5">
              <!-- Card interna de Parámetros y Filtros -->
              <v-card
                class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1"
              >
                <div
                  class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
                >
                  <div class="d-flex align-center">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-filter-variant</v-icon
                    >
                    <span
                      class="font-weight-bold text-caption text-uppercase text--primary"
                    >
                      Parámetros del Reporte e Información del Inspector
                    </span>
                  </div>
                </div>

                <div class="pa-4 pa-md-5">
                  <v-form ref="form" v-model="valid">
                    <v-row align="stretch">
                      <!-- Columna Inspector y Firma Digital -->
                      <v-col cols="12" md="4" lg="3">
                        <div
                          class="inspector-card-wrapper pa-3 h-100 d-flex flex-column justify-space-between"
                        >
                          <div>
                            <div class="firma-wrapper mb-2">
                              <div class="firma-badge">
                                <v-icon x-small color="primary" class="mr-1"
                                  >mdi-draw-pen</v-icon
                                >
                                <span>Firma del Inspector</span>
                              </div>
                              <div class="firma-box">
                                <v-img
                                  v-if="rutaImagenFirma && !errorCargaFirma"
                                  :src="rutaImagenFirma"
                                  alt="Firma"
                                  max-width="160"
                                  max-height="65"
                                  contain
                                  class="firma-img"
                                  @error="errorCargaFirma = true"
                                >
                                  <template v-slot:placeholder>
                                    <div
                                      class="d-flex align-center justify-center fill-height"
                                    >
                                      <v-progress-circular
                                        indeterminate
                                        size="18"
                                        width="2"
                                        color="primary"
                                      ></v-progress-circular>
                                    </div>
                                  </template>
                                </v-img>
                                <div
                                  v-else
                                  class="firma-fallback d-flex flex-column align-center justify-center"
                                >
                                  <v-icon small color="grey lighten-1"
                                    >mdi-signature-freehand</v-icon
                                  >
                                  <span
                                    class="text-caption grey--text text--darken-1"
                                    style="
                                      font-size: 10px !important;
                                      line-height: 1.1;
                                    "
                                  >
                                    Firma digital registrada
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <v-text-field
                            type="text"
                            v-model="nombreusuario"
                            label="Responsable / Inspector"
                            prepend-inner-icon="mdi-account-check-outline"
                            outlined
                            dense
                            readonly
                            required
                            hide-details="auto"
                            class="field-custom mt-2"
                          ></v-text-field>
                        </div>
                      </v-col>

                      <!-- Columna Periodo y Acciones -->
                      <v-col
                        cols="12"
                        md="8"
                        lg="9"
                        class="d-flex flex-column justify-space-between"
                      >
                        <div>
                          <div
                            class="text-caption font-weight-bold text-uppercase grey--text text--darken-2 mb-2 d-flex align-center"
                          >
                            <v-icon small color="primary" class="mr-1"
                              >mdi-calendar-range</v-icon
                            >
                            Periodo de Evaluación
                          </div>

                          <v-row dense>
                            <!-- Año -->
                            <v-col cols="12" sm="4">
                              <v-autocomplete
                                :items="Years"
                                v-model="Item.year"
                                label="Año *"
                                prepend-inner-icon="mdi-calendar"
                                :rules="[(v) => !!v || 'El año es requerido']"
                                @change="onMeses(Item.year)"
                                outlined
                                dense
                                hide-details="auto"
                                class="field-custom"
                              ></v-autocomplete>
                            </v-col>

                            <!-- Mes inicial -->
                            <v-col cols="12" sm="4">
                              <v-autocomplete
                                :items="Months"
                                v-model="Item.month1"
                                label="Mes inicial *"
                                prepend-inner-icon="mdi-calendar-start"
                                :rules="[(v) => !!v || 'El mes es requerido']"
                                @change="onCambioFiltros"
                                outlined
                                dense
                                hide-details="auto"
                                class="field-custom"
                              ></v-autocomplete>
                            </v-col>

                            <!-- Mes final -->
                            <v-col cols="12" sm="4">
                              <v-autocomplete
                                :items="Months"
                                v-model="Item.month2"
                                label="Mes final"
                                prepend-inner-icon="mdi-calendar-end"
                                @change="onCambioFiltros"
                                outlined
                                dense
                                hide-details="auto"
                                class="field-custom"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>

                          <div
                            class="mt-3 text-caption grey--text text--darken-1 d-flex align-start info-hint-block"
                          >
                            <v-icon
                              x-small
                              color="info"
                              class="mr-1 mt-1 flex-shrink-0"
                              >mdi-information-outline</v-icon
                            >
                            <span>
                              Haga clic en <strong>Consultar</strong>
                              para cargar la información consolidada o en
                              <strong>Exportar</strong> para generar el PDF.
                            </span>
                          </div>
                        </div>

                        <!-- Fila Botones de Acción -->
                        <div class="report-action-buttons-row">
                          <!-- Botón Consultar -->
                          <v-btn
                            class="btn-action-custom btn-consultar btn-action-responsive"
                            :loading="loader"
                            @click="consultarDatos"
                            :disabled="!valid"
                            height="40"
                          >
                            <v-icon left small>mdi-magnify</v-icon>
                            Consultar
                          </v-btn>

                          <!-- Botón Exportar -->
                          <v-btn
                            class="btn-action-custom btn-exportar btn-action-responsive"
                            :disabled="buttonExportar"
                            @click="abrirModalSeccionesExportar()"
                            height="40"
                          >
                            <v-icon left small>mdi-file-export-outline</v-icon>
                            Exportar
                          </v-btn>

                          <!-- Botón Cargar reporte con tooltip -->
                          <v-tooltip bottom v-if="role <= 3">
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                class="btn-action-responsive"
                              >
                                <v-btn
                                  class="btn-action-custom btn-cargar-reporte"
                                  :disabled="buttoncargarpdf"
                                  @click="abrirmodal(Item)"
                                  height="40"
                                  style="width: 100%"
                                >
                                  <v-icon left small
                                    >mdi-cloud-upload-outline</v-icon
                                  >
                                  Cargar reporte
                                </v-btn>
                              </span>
                            </template>
                            <span
                              >Cargue el reporte o revise las
                              observaciones</span
                            >
                          </v-tooltip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <br />

      <div v-if="visualizarReporte == true">
        <!--Seguimiento del reporte consolidado-->
        <v-row
          justify="center"
          v-if="
            loader || (listaEstadoReportes && listaEstadoReportes.length > 0)
          "
        >
          <v-col lg="12">
            <v-card
              class="rounded-lg elevation-2 overflow-hidden mb-4 tracking-card"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-3">
                <v-icon left small>mdi-timeline-clock-outline</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Seguimiento del Reporte Consolidado
                </span>
              </v-toolbar>

              <div class="tracking-table-wrapper">
                <table class="modern-tracking-table" style="width: 100%">
                  <thead>
                    <tr>
                      <th style="width: 25%">
                        <div class="d-flex align-center justify-center">
                          <v-icon x-small color="grey darken-1" class="mr-1"
                            >mdi-calendar-range</v-icon
                          >
                          <span>Periodo</span>
                        </div>
                      </th>
                      <th style="width: 20%">
                        <div class="d-flex align-center justify-center">
                          <v-icon x-small color="grey darken-1" class="mr-1"
                            >mdi-progress-check</v-icon
                          >
                          <span>Estado</span>
                        </div>
                      </th>
                      <th style="width: 30%">
                        <div class="d-flex align-center justify-center">
                          <v-icon x-small color="grey darken-1" class="mr-1"
                            >mdi-clock-outline</v-icon
                          >
                          <span>Fecha de actualización</span>
                        </div>
                      </th>
                      <th style="width: 25%">
                        <div class="d-flex align-center justify-center">
                          <v-icon x-small color="grey darken-1" class="mr-1"
                            >mdi-comment-text-multiple-outline</v-icon
                          >
                          <span>Observaciones / Mensajes</span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loader">
                      <td colspan="4" class="text-center py-6">
                        <div
                          class="d-flex flex-column align-center justify-center py-4"
                        >
                          <v-progress-circular
                            indeterminate
                            color="secondary"
                            size="34"
                            width="3"
                            class="mb-2"
                          ></v-progress-circular>
                          <span
                            class="caption grey--text text--darken-2 font-weight-medium"
                          >
                            Cargando seguimiento del reporte...
                          </span>
                        </div>
                      </td>
                    </tr>
                    <template v-else>
                      <tr
                        v-for="(item, index) in listaEstadoReportes"
                        :key="index"
                        class="tracking-table-row"
                      >
                        <td
                          class="text-center font-weight-medium text-body-2 py-3 px-2"
                        >
                          <div
                            class="d-inline-flex align-center tracking-period-badge px-3 py-1 rounded-pill"
                          >
                            <v-icon x-small color="primary" class="mr-1"
                              >mdi-calendar-month</v-icon
                            >
                            <span>{{ formatearRangoMeses(item) }}</span>
                          </div>
                        </td>
                        <td class="text-center py-3 px-2">
                          <v-chip
                            :color="
                              item.estado == 'APROBADO'
                                ? 'success'
                                : item.estado == 'RECHAZADO'
                                ? 'error'
                                : item.estado == 'NO ENVIADO'
                                ? 'grey darken-1'
                                : 'info'
                            "
                            small
                            dark
                            class="font-weight-bold px-3 elevation-1"
                          >
                            <v-icon left x-small>
                              {{
                                item.estado == "APROBADO"
                                  ? "mdi-check-circle"
                                  : item.estado == "RECHAZADO"
                                  ? "mdi-close-circle"
                                  : item.estado == "NO ENVIADO"
                                  ? "mdi-timer-sand"
                                  : "mdi-alert-circle"
                              }}
                            </v-icon>
                            {{ item.estado }}
                          </v-chip>
                        </td>
                        <td
                          class="text-center text-caption font-weight-medium grey--text text--darken-2 py-3 px-2"
                        >
                          <div class="d-inline-flex align-center">
                            <v-icon x-small color="grey darken-1" class="mr-1"
                              >mdi-clock-outline</v-icon
                            >
                            <span>{{
                              formatearFechaHora(item.created_at)
                            }}</span>
                          </div>
                        </td>
                        <td class="text-center py-3 px-2">
                          <v-tooltip bottom v-if="item.id">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                height="30"
                                width="30"
                                color="amber darken-3"
                                fab
                                x-small
                                dark
                                class="elevation-1 action-comment-btn"
                                @click="abrirComentariosVisual(item)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon small>mdi-comment-text-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Ver observaciones</span>
                          </v-tooltip>
                          <span v-else class="grey--text text-caption">-</span>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          !listaEstadoReportes ||
                          listaEstadoReportes.length === 0
                        "
                      >
                        <td colspan="4" class="text-center py-6 grey--text">
                          <v-icon color="grey lighten-1" class="mb-1"
                            >mdi-information-outline</v-icon
                          >
                          <div class="caption">
                            No hay información de seguimiento para este período.
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <Comentarios
          :dialog="dialogComentarios"
          @dialog="dialogComentarios = $event"
          :Item="itemComentarioSelected"
          :soloLectura="true"
        />
        <!--Recomendaciones-->
        <v-row justify="center">
          <v-col lg="12">
            <v-card class="rounded-lg elevation-2 overflow-hidden mb-4">
              <v-toolbar height="54" color="#243042" dark flat class="px-3 rec-toolbar">
                <v-icon left small>mdi-comment-text-multiple-outline</v-icon>
                <span class="text-subtitle-1 font-weight-bold rec-toolbar-title">
                  Recomendaciones Técnicas
                </span>
                <v-spacer></v-spacer>
                <v-chip
                  x-small
                  color="white"
                  text-color="#243042"
                  class="font-weight-bold"
                >
                  Observaciones
                </v-chip>
              </v-toolbar>
              <v-container class="pa-2 pa-sm-4">
                <!-- Caja para nueva recomendación -->
                <div class="rec-form-wrapper pa-3 pa-sm-4 mb-4">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <div class="d-flex align-center">
                      <v-icon small color="#243042" class="mr-2"
                        >mdi-pencil-box-multiple-outline</v-icon
                      >
                      <span
                        class="text-subtitle-2 font-weight-bold grey--text text--darken-3"
                      >
                        Agregar Nueva Recomendación
                      </span>
                    </div>
                    <span class="caption grey--text d-none d-sm-inline">
                      Redacte observaciones y recomendaciones técnicas para la
                      flota
                    </span>
                  </div>
                  <v-textarea
                    autocomplete="recomendacion"
                    placeholder="Escriba aquí la recomendación técnica a registrar..."
                    v-model="recomendacion.descripcion"
                    rows="2"
                    auto-grow
                    outlined
                    dense
                    hide-details="auto"
                    class="rec-textarea-input mb-3"
                  ></v-textarea>
                  <div class="d-flex justify-end rec-form-actions">
                    <v-btn
                      color="#243042"
                      dark
                      class="elevation-1 font-weight-bold rounded-lg text-none px-4 rec-save-btn"
                      height="36"
                      @click="guardarRecomendacion()"
                    >
                      <v-icon left small>mdi-content-save-outline</v-icon>
                      Guardar recomendación
                    </v-btn>
                  </div>
                </div>

                <!-- Tabla moderna de recomendaciones registradas -->
                <div
                  class="rec-table-container rounded-lg border overflow-hidden elevation-1"
                >
                  <table class="modern-rec-table">
                    <thead>
                      <tr>
                        <th style="width: 50px" class="text-center">#</th>
                        <th>Recomendaciones Registradas</th>
                        <th style="width: 120px" class="text-center">
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in Recomendaciones"
                        :key="index"
                        class="rec-table-row"
                      >
                        <td class="text-center rec-cell-num">
                          <div class="d-flex align-center justify-center rec-badge-wrapper">
                            <span class="rec-num-badge">{{ index + 1 }}</span>
                            <span class="d-inline d-sm-none text-caption font-weight-bold grey--text text--darken-3 ml-2">
                              Recomendación #{{ index + 1 }}
                            </span>
                          </div>
                        </td>
                        <td class="rec-cell-desc py-2">
                          <v-textarea
                            class="rec-row-textarea letra-11"
                            clear-icon="mdi-close-circle"
                            clearable
                            v-model="item.recomendaciones"
                            rows="2"
                            auto-grow
                            outlined
                            dense
                            hide-details="auto"
                            placeholder="Descripción de la recomendación..."
                          ></v-textarea>
                        </td>
                        <td class="text-center rec-cell-actions">
                          <div class="d-flex align-center justify-center rec-actions-wrap">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  depressed
                                  color="primary"
                                  class="rounded-lg mr-2 rec-action-btn"
                                  min-width="32"
                                  width="32"
                                  height="32"
                                  @click="guardarRecomendacion(item)"
                                >
                                  <v-icon small>mdi-content-save</v-icon>
                                </v-btn>
                              </template>
                              <span>Guardar cambios</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  depressed
                                  color="error"
                                  class="rounded-lg rec-action-btn"
                                  min-width="32"
                                  width="32"
                                  height="32"
                                  @click="eliminarRecomendacion(index, item)"
                                >
                                  <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>Eliminar recomendación</span>
                            </v-tooltip>
                          </div>
                        </td>
                      </tr>
                      <tr
                        v-if="!Recomendaciones || Recomendaciones.length === 0"
                      >
                        <td
                          colspan="3"
                          class="text-center py-6 text-body-2 grey--text"
                        >
                          <v-icon small color="grey" class="mr-1"
                            >mdi-clipboard-text-outline</v-icon
                          >
                          No se han registrado recomendaciones técnicas aún.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <!--Equipos inspeccionados-->
        <v-row justify="center">
          <v-col cols="12" lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <!-- Toolbar principal -->
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-truck-check</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Equipos Inspeccionados
                </span>
              </v-toolbar>

              <!-- Subtítulo descriptivo -->
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span class="text-caption grey--text text--darken-2">
                    Detalle cuantitativo de la flota evaluada: configuración de
                    vehículos y distribución de neumáticos por eje
                  </span>
                </div>
              </div>

              <!-- Contenedor de la tabla -->
              <div class="pa-4">
                <div
                  class="equipos-table-wrapper rounded-lg border overflow-hidden"
                >
                  <div class="table-responsive" style="overflow-x: auto">
                    <table
                      class="modern-equipos-table"
                      style="min-width: 780px; width: 100%"
                    >
                      <thead>
                        <!-- Nivel 1: Agrupación Principal -->
                        <tr class="header-group-row">
                          <th
                            colspan="4"
                            class="text-center group-header-vehiculo"
                          >
                            <v-icon x-small color="white" class="mr-1"
                              >mdi-truck</v-icon
                            >
                            EQUIPO / VEHÍCULO
                          </th>
                          <th
                            colspan="6"
                            class="text-center group-header-neumatico"
                          >
                            <v-icon x-small color="white" class="mr-1"
                              >mdi-tire</v-icon
                            >
                            DISTRIBUCIÓN DE NEUMÁTICOS POR EJE
                          </th>
                          <th
                            rowspan="3"
                            class="text-center group-header-total"
                          >
                            <div
                              class="d-flex flex-column align-center justify-center fill-height"
                            >
                              <v-icon x-small color="white" class="mb-1"
                                >mdi-sigma</v-icon
                              >
                              <span>TOTAL NEUM.</span>
                            </div>
                          </th>
                        </tr>

                        <!-- Nivel 2: Columnas de Equipo y Subgrupos de Ejes -->
                        <tr class="header-subgroup-row">
                          <th rowspan="2" class="text-center col-tipo">Tipo</th>
                          <th rowspan="2" class="text-center col-marca">
                            Marca
                          </th>
                          <th rowspan="2" class="text-center col-modelo">
                            Modelo
                          </th>
                          <th rowspan="2" class="text-center col-total-veh">
                            Cant. Veh.
                          </th>

                          <th
                            colspan="2"
                            class="text-center eje-th eje-th-delantero"
                          >
                            Delantero
                          </th>
                          <th
                            colspan="2"
                            class="text-center eje-th eje-th-posterior"
                          >
                            Posterior
                          </th>
                          <th
                            colspan="2"
                            class="text-center eje-th eje-th-libre"
                          >
                            Eje Libre
                          </th>
                        </tr>

                        <!-- Nivel 3: Medida y Cantidad -->
                        <tr class="header-leaf-row">
                          <th class="text-center col-medida">Medida</th>
                          <th class="text-center col-cant">Cant.</th>
                          <th class="text-center col-medida">Medida</th>
                          <th class="text-center col-cant">Cant.</th>
                          <th class="text-center col-medida">Medida</th>
                          <th class="text-center col-cant">Cant.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in EquiposInspeccionados"
                          :key="index"
                          class="equipos-data-row"
                        >
                          <!-- Tipo -->
                          <td class="text-center">
                            <span class="tipo-badge">{{ item.nomtipo }}</span>
                          </td>

                          <!-- Marca -->
                          <td class="text-center font-weight-medium">
                            {{ item.marca }}
                          </td>

                          <!-- Modelo -->
                          <td class="text-center font-weight-medium">
                            {{ item.modelo }}
                          </td>

                          <!-- Cant. Vehículos -->
                          <td class="text-center">
                            <span class="badge-vehiculo-count">
                              {{ item.total_vehiculos }}
                            </span>
                          </td>

                          <!-- Eje Delantero: Medida -->
                          <td class="pa-0 text-center sub-cell-col">
                            <div
                              v-if="
                                item.ejes_delanteros &&
                                item.ejes_delanteros.length > 0
                              "
                              class="sub-items-container"
                            >
                              <div
                                v-for="(item2, index2) in item.ejes_delanteros"
                                :key="'del-m-' + index2"
                                class="sub-item-cell font-weight-medium text-truncate px-2"
                                :title="item2.descripcion"
                              >
                                {{ item2.descripcion }}
                              </div>
                            </div>
                            <span v-else class="grey--text text-caption"
                              >-</span
                            >
                          </td>

                          <!-- Eje Delantero: Cantidad -->
                          <td class="pa-0 text-center sub-cell-col">
                            <div
                              v-if="
                                item.ejes_delanteros &&
                                item.ejes_delanteros.length > 0
                              "
                              class="sub-items-container"
                            >
                              <div
                                v-for="(item2, index2) in item.ejes_delanteros"
                                :key="'del-c-' + index2"
                                class="sub-item-cell"
                              >
                                <span class="badge-cant badge-cant-delantero">
                                  {{ item2.cantidad }}
                                </span>
                              </div>
                            </div>
                            <span v-else class="grey--text text-caption"
                              >-</span
                            >
                          </td>

                          <!-- Eje Posterior: Medida -->
                          <td class="pa-0 text-center sub-cell-col">
                            <div
                              v-if="
                                item.ejes_posteriores &&
                                item.ejes_posteriores.length > 0
                              "
                              class="sub-items-container"
                            >
                              <div
                                v-for="(item2, index2) in item.ejes_posteriores"
                                :key="'post-m-' + index2"
                                class="sub-item-cell font-weight-medium text-truncate px-2"
                                :title="item2.descripcion"
                              >
                                {{ item2.descripcion }}
                              </div>
                            </div>
                            <span v-else class="grey--text text-caption"
                              >-</span
                            >
                          </td>

                          <!-- Eje Posterior: Cantidad -->
                          <td class="pa-0 text-center sub-cell-col">
                            <div
                              v-if="
                                item.ejes_posteriores &&
                                item.ejes_posteriores.length > 0
                              "
                              class="sub-items-container"
                            >
                              <div
                                v-for="(item2, index2) in item.ejes_posteriores"
                                :key="'post-c-' + index2"
                                class="sub-item-cell"
                              >
                                <span class="badge-cant badge-cant-posterior">
                                  {{ item2.cantidad }}
                                </span>
                              </div>
                            </div>
                            <span v-else class="grey--text text-caption"
                              >-</span
                            >
                          </td>

                          <!-- Eje Libre: Medida -->
                          <td class="pa-0 text-center sub-cell-col">
                            <div
                              v-if="
                                item.ejes_libres && item.ejes_libres.length > 0
                              "
                              class="sub-items-container"
                            >
                              <div
                                v-for="(item2, index2) in item.ejes_libres"
                                :key="'lib-m-' + index2"
                                class="sub-item-cell font-weight-medium text-truncate px-2"
                                :title="item2.descripcion"
                              >
                                {{ item2.descripcion }}
                              </div>
                            </div>
                            <span v-else class="grey--text text-caption"
                              >-</span
                            >
                          </td>

                          <!-- Eje Libre: Cantidad -->
                          <td class="pa-0 text-center sub-cell-col">
                            <div
                              v-if="
                                item.ejes_libres && item.ejes_libres.length > 0
                              "
                              class="sub-items-container"
                            >
                              <div
                                v-for="(item2, index2) in item.ejes_libres"
                                :key="'lib-c-' + index2"
                                class="sub-item-cell"
                              >
                                <span class="badge-cant badge-cant-libre">
                                  {{ item2.cantidad }}
                                </span>
                              </div>
                            </div>
                            <span v-else class="grey--text text-caption"
                              >-</span
                            >
                          </td>

                          <!-- Total Neumáticos -->
                          <td class="text-center">
                            <span class="badge-neumatico-total">
                              {{ item.total_neumaticos }}
                            </span>
                          </td>
                        </tr>

                        <!-- Estado vacío -->
                        <tr
                          v-if="
                            !EquiposInspeccionados ||
                            EquiposInspeccionados.length === 0
                          "
                        >
                          <td colspan="11" class="text-center py-8">
                            <v-icon
                              size="36"
                              color="grey lighten-1"
                              class="mb-2"
                            >
                              mdi-truck-remove-outline
                            </v-icon>
                            <div
                              class="text-body-2 grey--text text--darken-1 font-weight-medium"
                            >
                              No hay equipos inspeccionados para el periodo
                              seleccionado.
                            </div>
                          </td>
                        </tr>
                      </tbody>

                      <!-- Pie de Totales -->
                      <tfoot
                        v-if="
                          EquiposInspeccionados &&
                          EquiposInspeccionados.length > 0
                        "
                      >
                        <tr class="table-totals-row">
                          <td
                            colspan="3"
                            class="text-right font-weight-bold pr-3"
                          >
                            TOTALES CONSOLIDADOS:
                          </td>
                          <td class="text-center">
                            <span class="badge-vehiculo-count font-weight-bold">
                              {{
                                EquiposInspeccionados.reduce(
                                  (acc, curr) =>
                                    acc + (parseInt(curr.total_vehiculos) || 0),
                                  0,
                                )
                              }}
                            </span>
                          </td>
                          <td
                            colspan="6"
                            class="text-center caption grey--text text--darken-2 font-weight-medium"
                          >
                            {{ EquiposInspeccionados.length }} modelos evaluados
                          </td>
                          <td class="text-center">
                            <span
                              class="badge-neumatico-total font-weight-bold"
                            >
                              {{
                                EquiposInspeccionados.reduce(
                                  (acc, curr) =>
                                    acc +
                                    (parseInt(curr.total_neumaticos) || 0),
                                  0,
                                )
                              }}
                            </span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Distribución de medida de neumáticos y posición de rueda segun marca-->
        <!--Distribución de medida de neumáticos y posición de rueda segun marca-->
        <v-row justify="center">
          <v-col cols="12" md="6" lg="6">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-3">
                <v-icon left small>mdi-chart-pie</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Distribución de Medidas de Neumáticos
                </span>
              </v-toolbar>
              <div class="chart-subtitle-bar px-4 py-2 d-flex align-center">
                <v-icon x-small color="grey darken-1" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                <span class="text-caption grey--text text--darken-2">
                  Proporción y porcentaje de medidas instaladas en la flota
                </span>
              </div>
              <v-divider></v-divider>
              <div
                class="chart-canvas-container pa-3 pa-md-4 flex-grow-1 d-flex align-center justify-center"
                v-if="DistribucionMedidasNeumaticos.length > 0"
              >
                <canvas
                  ref="elemento"
                  id="pieMedidas"
                  style="max-height: 400px; width: 100%"
                ></canvas>
              </div>
              <div
                class="chart-empty-state py-10 px-4 text-center d-flex flex-column align-center justify-center fill-height"
                v-else
              >
                <v-icon size="44" color="grey lighten-1" class="mb-2"
                  >mdi-chart-pie</v-icon
                >
                <span
                  class="text-body-2 grey--text text--darken-1 font-weight-medium"
                >
                  No hay datos disponibles para distribución de medidas
                </span>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-3">
                <v-icon left small>mdi-tire</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Posición de Rueda Según Marca
                </span>
              </v-toolbar>
              <div class="chart-subtitle-bar px-4 py-2 d-flex align-center">
                <v-icon x-small color="grey darken-1" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                <span class="text-caption grey--text text--darken-2">
                  Desglose de marcas de neumáticos según su posición de rueda
                </span>
              </div>
              <v-divider></v-divider>
              <div
                class="chart-canvas-container pa-3 pa-md-4 flex-grow-1 d-flex align-center justify-center"
                v-if="PosicionRuedaSegunMarca.length > 0"
              >
                <canvas
                  ref="elemento"
                  id="pieMarcas"
                  style="max-height: 400px; width: 100%"
                ></canvas>
              </div>
              <div
                class="chart-empty-state py-10 px-4 text-center d-flex flex-column align-center justify-center fill-height"
                v-else
              >
                <v-icon size="44" color="grey lighten-1" class="mb-2"
                  >mdi-chart-donut</v-icon
                >
                <span
                  class="text-body-2 grey--text text--darken-1 font-weight-medium"
                >
                  No hay datos para posición de rueda según marca
                </span>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!--Distribución de marcas por eje-->
        <v-row justify="center" class="mt-2">
          <v-col cols="12" md="6" lg="6">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-3">
                <v-icon left small>mdi-steering</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Distribución de Marcas por Eje Direccional
                </span>
              </v-toolbar>
              <div class="chart-subtitle-bar px-4 py-2 d-flex align-center">
                <v-icon x-small color="grey darken-1" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                <span class="text-caption grey--text text--darken-2">
                  Volumen y marcas operando en posiciones de dirección
                </span>
              </div>
              <v-divider></v-divider>
              <div
                class="chart-canvas-container pa-3 pa-md-4 flex-grow-1 d-flex align-center justify-center"
                v-if="DistribucionEjeDireccional.length > 0"
              >
                <canvas
                  ref="elemento"
                  id="barDireccional"
                  style="max-height: 400px; width: 100%"
                ></canvas>
              </div>
              <div
                class="chart-empty-state py-10 px-4 text-center d-flex flex-column align-center justify-center fill-height"
                v-else
              >
                <v-icon size="44" color="grey lighten-1" class="mb-2"
                  >mdi-chart-bar</v-icon
                >
                <span
                  class="text-body-2 grey--text text--darken-1 font-weight-medium"
                >
                  No hay datos para distribución por eje direccional
                </span>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-3">
                <v-icon left small>mdi-cog-sync</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Distribución de Marcas por Eje Tracción
                </span>
              </v-toolbar>
              <div class="chart-subtitle-bar px-4 py-2 d-flex align-center">
                <v-icon x-small color="grey darken-1" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                <span class="text-caption grey--text text--darken-2">
                  Marcas instaladas en ejes de tracción motriz
                </span>
              </div>
              <v-divider></v-divider>
              <div
                class="chart-canvas-container pa-3 pa-md-4 flex-grow-1 d-flex align-center justify-center"
                v-if="DistribucionEjeTraccion.length > 0"
              >
                <canvas
                  ref="elemento"
                  id="barTraccion"
                  style="max-height: 400px; width: 100%"
                ></canvas>
              </div>
              <div
                class="chart-empty-state py-10 px-4 text-center d-flex flex-column align-center justify-center fill-height"
                v-else
              >
                <v-icon size="44" color="grey lighten-1" class="mb-2"
                  >mdi-chart-bar</v-icon
                >
                <span
                  class="text-body-2 grey--text text--darken-1 font-weight-medium"
                >
                  No hay datos para distribución por eje tracción
                </span>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-row justify="start" class="mt-2">
          <v-col cols="12" md="6" lg="6">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-3">
                <v-icon left small>mdi-truck-trailer</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Distribución de Marcas por Eje de Apoyo / Libre
                </span>
              </v-toolbar>
              <div class="chart-subtitle-bar px-4 py-2 d-flex align-center">
                <v-icon x-small color="grey darken-1" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                <span class="text-caption grey--text text--darken-2">
                  Participación de marcas en ejes libres, de arrastre y remolque
                </span>
              </div>
              <v-divider></v-divider>
              <div
                class="chart-canvas-container pa-3 pa-md-4 flex-grow-1 d-flex align-center justify-center"
                v-if="DistribucionEjeLibre.length > 0"
              >
                <canvas
                  ref="elemento"
                  id="barLibre"
                  style="max-height: 400px; width: 100%"
                ></canvas>
              </div>
              <div
                class="chart-empty-state py-10 px-4 text-center d-flex flex-column align-center justify-center fill-height"
                v-else
              >
                <v-icon size="44" color="grey lighten-1" class="mb-2"
                  >mdi-chart-bar</v-icon
                >
                <span
                  class="text-body-2 grey--text text--darken-1 font-weight-medium"
                >
                  No hay datos para distribución por eje de apoyo
                </span>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Resumen de neumáticos en mal estado-->
        <v-row justify="center">
          <v-col lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-alert-octagon-outline</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Resumen de Neumáticos En Mal Estado
                </span>
                <v-spacer></v-spacer>
                <v-chip
                  v-if="NeumaticosMalEstado && NeumaticosMalEstado.length > 0"
                  x-small
                  color="red darken-1"
                  dark
                  class="font-weight-bold mr-2 d-none d-sm-inline-flex"
                >
                  <v-icon left x-small>mdi-alert-circle</v-icon>
                  {{ NeumaticosMalEstado.length }} Neumáticos
                </v-chip>
              </v-toolbar>

              <!-- Subtítulo descriptivo -->
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span class="text-caption grey--text text--darken-2">
                    Detalle de neumáticos inspeccionados con condiciones
                    críticas, desgaste irregular o anomalías
                  </span>
                </div>
              </div>

              <!-- Contenedor de la tabla -->
              <div class="pa-4">
                <div
                  class="mal-estado-table-wrapper rounded-lg border overflow-hidden elevation-1"
                >
                  <div class="table-responsive" style="overflow-x: auto">
                    <table
                      class="modern-mal-estado-table"
                      id="table"
                      style="width: 100%"
                    >
                      <thead>
                        <tr>
                          <th style="width: 8%" class="text-center">Placa</th>
                          <th style="width: 5%" class="text-center">Pos</th>
                          <th style="width: 8%" class="text-center">Eje</th>
                          <th style="width: 9%">Marca</th>
                          <th style="width: 9%">Medida</th>
                          <th style="width: 9%">Modelo</th>
                          <th style="width: 8%" class="text-center">Estado</th>
                          <th style="width: 8%">Diseño</th>
                          <th style="width: 10%">Serie</th>
                          <th style="width: 6%" class="text-center">NSD</th>
                          <th style="width: 12%">Observaciones</th>
                          <th style="width: 8%" class="text-center">Imagen</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in NeumaticosMalEstado"
                          :key="index"
                          class="mal-estado-data-row"
                        >
                          <td class="text-center">
                            <span class="plate-badge">{{
                              item.placa || "-"
                            }}</span>
                          </td>
                          <td class="text-center">
                            <span class="pos-badge">{{
                              item.neumatico_posicion || "-"
                            }}</span>
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item.eje || "-" }}
                          </td>
                          <td
                            class="font-weight-bold text-uppercase"
                            style="color: #1e293b"
                          >
                            {{ item.marca || "-" }}
                          </td>
                          <td>{{ item.medida || "-" }}</td>
                          <td>{{ item.modelo || "-" }}</td>
                          <td class="text-center">
                            <span class="estado-alert-badge">
                              {{ item.estado || "-" }}
                            </span>
                          </td>
                          <td>{{ item.disenio || "-" }}</td>
                          <td
                            class="font-weight-medium text-caption"
                            style="font-family: monospace"
                          >
                            {{ item.serieneumatico || "-" }}
                          </td>
                          <td class="text-center">
                            <span class="nsd-badge">{{
                              item.nsd != null ? item.nsd : "-"
                            }}</span>
                          </td>
                          <td class="observaciones-cell">
                            <span class="text-caption font-weight-medium">{{
                              item.observaciones || "-"
                            }}</span>
                          </td>
                          <td class="text-center">
                            <div
                              v-if="item.ruta1 != null"
                              class="img-preview-box"
                            >
                              <a
                                :href="ruta_image + item.ruta1"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  :src="ruta_image + item.ruta1"
                                  alt="Neumático en mal estado"
                                  class="mal-estado-img rounded"
                                />
                              </a>
                            </div>
                            <span v-else class="grey--text text-caption"
                              >-</span
                            >
                          </td>
                        </tr>
                        <tr
                          v-if="
                            !NeumaticosMalEstado ||
                            NeumaticosMalEstado.length == 0
                          "
                        >
                          <td
                            colspan="12"
                            class="text-center py-8 text-body-2 grey--text"
                          >
                            <v-icon size="28" color="success" class="mr-2"
                              >mdi-check-circle-outline</v-icon
                            >
                            No hay neumáticos en mal estado registrados en este
                            reporte
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Resumen de neumáticos en scrap-->
        <v-row justify="center">
          <v-col lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-delete-alert-outline</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Resumen de Neumáticos En Scrap
                </span>
                <v-spacer> </v-spacer>
                <v-chip
                  v-if="NeumaticosScrap && NeumaticosScrap.length > 0"
                  x-small
                  color="orange darken-2"
                  dark
                  class="font-weight-bold mr-2 d-none d-sm-inline-flex"
                >
                  <v-icon left x-small>mdi-trash-can</v-icon>
                  {{ NeumaticosScrap.length }} Motivos
                </v-chip>
                <v-btn
                  height="30"
                  width="30"
                  color="green darken-1"
                  fab
                  x-small
                  dark
                  elevation="1"
                  @click="exportarAExcelScrapxMotivo()"
                  :loading="loadingExcelScrap"
                  title="Exportar a Excel"
                >
                  <v-icon small>mdi-file-excel</v-icon>
                </v-btn>
              </v-toolbar>

              <!-- Subtítulo descriptivo -->
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span class="text-caption grey--text text--darken-2">
                    Distribución y proporción de neumáticos dados de baja según
                    motivo de desecho
                  </span>
                </div>
              </div>

              <div class="pa-4">
                <div
                  class="table-card-wrapper rounded-lg border overflow-hidden elevation-1"
                >
                  <div class="table-responsive" style="overflow-x: auto">
                    <table class="modern-report-table" style="width: 100%">
                      <thead>
                        <tr>
                          <th style="width: 50%">Motivo Retiro</th>
                          <th style="width: 25%" class="text-center">
                            Cantidad
                          </th>
                          <th style="width: 25%" class="text-center">
                            Porcentaje
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in NeumaticosScrap"
                          :key="index"
                          class="report-data-row"
                        >
                          <td class="font-weight-medium" style="color: #1e293b">
                            {{ item.motivo }}
                          </td>
                          <td class="text-center font-weight-bold">
                            <span class="count-badge">{{ item.cantidad }}</span>
                          </td>
                          <td class="text-center">
                            <span class="percent-badge"
                              >{{ item.porcentaje }} %</span
                            >
                          </td>
                        </tr>
                        <tr
                          v-if="!NeumaticosScrap || NeumaticosScrap.length == 0"
                        >
                          <td class="text-center py-6 grey--text" colspan="3">
                            <v-icon
                              size="24"
                              color="grey lighten-1"
                              class="mr-1"
                              >mdi-clipboard-text-outline</v-icon
                            >
                            No hay neumáticos en scrap registrados
                          </td>
                        </tr>
                      </tbody>
                      <tfoot
                        v-if="NeumaticosScrap && NeumaticosScrap.length > 0"
                      >
                        <tr class="table-totals-row">
                          <td class="text-right font-weight-bold">
                            TOTAL GENERAL
                          </td>
                          <td class="text-center font-weight-bold">
                            <span class="count-badge count-badge-total">
                              {{ calcularCantidadNeumaticosScrap() }}
                            </span>
                          </td>
                          <td class="text-center font-weight-bold">
                            <span class="percent-badge percent-badge-total"
                              >100 %</span
                            >
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Resumen de neumáticos en retiro-->
        <v-row justify="center">
          <v-col lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-car-tire-alert</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Resumen de Neumáticos En Retiro
                </span>
                <v-spacer></v-spacer>
                <v-chip
                  v-if="NeumaticosRetiro && NeumaticosRetiro.length > 0"
                  x-small
                  color="amber darken-3"
                  dark
                  class="font-weight-bold mr-2 d-none d-sm-inline-flex"
                >
                  <v-icon left x-small>mdi-tire</v-icon>
                  {{ NeumaticosRetiro.length }} Neumáticos
                </v-chip>
              </v-toolbar>

              <!-- Subtítulo descriptivo -->
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span class="text-caption grey--text text--darken-2">
                    Detalle de neumáticos retirados de operación para
                    inspección, mantenimiento o disposición
                  </span>
                </div>
              </div>

              <div class="pa-4">
                <div
                  class="table-card-wrapper rounded-lg border overflow-hidden elevation-1"
                >
                  <div class="table-responsive" style="overflow-x: auto">
                    <table class="modern-report-table" style="width: 100%">
                      <thead>
                        <tr>
                          <th style="width: 8%" class="text-center">
                            Vehículo
                          </th>
                          <th style="width: 5%" class="text-center">POS</th>
                          <th style="width: 9%">Marca</th>
                          <th style="width: 9%">Medidas</th>
                          <th style="width: 8%">Diseño</th>
                          <th style="width: 8%" class="text-center">Estado</th>
                          <th style="width: 9%">Serie</th>
                          <th style="width: 6%" class="text-center">1</th>
                          <th style="width: 6%" class="text-center">2</th>
                          <th style="width: 6%" class="text-center">NSD</th>
                          <th style="width: 18%">Recomendación</th>
                          <th style="width: 8%" class="text-center">Imagen</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in NeumaticosRetiro"
                          :key="index"
                          class="report-data-row"
                        >
                          <td class="text-center">
                            <span class="plate-badge">{{
                              item.placa || "-"
                            }}</span>
                          </td>
                          <td class="text-center">
                            <span class="pos-badge">{{
                              item.posicion || "-"
                            }}</span>
                          </td>
                          <td
                            class="font-weight-bold text-uppercase"
                            style="color: #1e293b"
                          >
                            {{ item.marca || "-" }}
                          </td>
                          <td>{{ item.medida || "-" }}</td>
                          <td>{{ item.disenio || "-" }}</td>
                          <td class="text-center">
                            <span class="condition-badge">{{
                              item.condicion || "-"
                            }}</span>
                          </td>
                          <td
                            class="font-weight-medium text-caption"
                            style="font-family: monospace"
                          >
                            {{ item.num_serie || "-" }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item.exterior || "-" }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item.interior || "-" }}
                          </td>
                          <td class="text-center">
                            <span class="nsd-badge">{{
                              item.nsd != null ? item.nsd : "-"
                            }}</span>
                          </td>
                          <td class="observaciones-cell">
                            <span class="text-caption font-weight-medium">{{
                              item.recomendacion || "-"
                            }}</span>
                          </td>
                          <td class="text-center">
                            <div
                              v-if="item.imagen1 != null"
                              class="img-preview-box"
                            >
                              <a
                                :href="ruta_image + item.imagen1"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  :src="ruta_image + item.imagen1"
                                  alt="Neumático en retiro"
                                  class="mal-estado-img rounded"
                                />
                              </a>
                            </div>
                            <span v-else class="grey--text text-caption"
                              >-</span
                            >
                          </td>
                        </tr>
                        <tr
                          v-if="
                            !NeumaticosRetiro || NeumaticosRetiro.length == 0
                          "
                        >
                          <td
                            class="text-center py-8 text-body-2 grey--text"
                            colspan="12"
                          >
                            <v-icon size="28" color="success" class="mr-2"
                              >mdi-check-circle-outline</v-icon
                            >
                            No hay neumáticos en retiro registrados
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Niveles de remanente por unidad-->
        <v-row justify="center">
          <v-col lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-gauge</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Niveles de Remanente por Unidad
                </span>
              </v-toolbar>

              <!-- Subtítulo descriptivo -->
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span class="text-caption grey--text text--darken-2">
                    Profundidad de remanente (mm) por posición vehicular y
                    unidades en umbral de reencauche
                  </span>
                </div>
              </div>

              <div class="pa-4">
                <div
                  class="table-card-wrapper rounded-lg border overflow-hidden elevation-1"
                >
                  <div class="table-responsive" style="overflow-x: auto">
                    <table
                      class="modern-report-table modern-remanente-table"
                      style="width: 100%"
                    >
                      <thead>
                        <tr class="header-group-row">
                          <th
                            colspan="2"
                            class="text-center"
                            style="width: 16%"
                          >
                            VEHÍCULO
                          </th>
                          <th
                            :colspan="NivelesRemanenteUnidadPosiciones.length"
                            class="text-center"
                          >
                            POSICIONES EVALUADAS (MM)
                          </th>
                          <th rowspan="2" class="text-center" style="width: 7%">
                            TOTAL
                          </th>
                          <th
                            colspan="2"
                            class="text-center"
                            style="width: 14%"
                          >
                            PARA REEMPLAZAR
                          </th>
                        </tr>
                        <tr class="header-leaf-row">
                          <th style="width: 8%" class="text-center">
                            Vehículo
                          </th>
                          <th style="width: 8%" class="text-center">Placa</th>
                          <th
                            style="width: 38px"
                            class="text-center"
                            v-for="(
                              item, index
                            ) in NivelesRemanenteUnidadPosiciones"
                            :key="index"
                          >
                            {{ item }}
                          </th>
                          <th style="width: 7%" class="text-center">
                            Reencauchar
                          </th>
                          <th style="width: 7%" class="text-center">
                            Próx. a Reenc.
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in NivelesRemanenteUnidad"
                          :key="index"
                          class="report-data-row"
                        >
                          <td class="text-center font-weight-medium">
                            {{ item.tipovehiculo }}
                          </td>
                          <td class="text-center">
                            <span class="plate-badge">{{ item.placa }}</span>
                          </td>
                          <td
                            v-for="(
                              item2, index2
                            ) in NivelesRemanenteUnidadPosiciones"
                            :key="index2"
                            :class="
                              tdPintar(
                                tdValorPosicion(index, item2),
                                item.rem_reencauche,
                                item.rem_proximo,
                              )
                            "
                          >
                            {{ tdValorPosicion(index, item2) }}
                          </td>
                          <td class="text-center font-weight-bold">
                            {{ item.total_neumaticos }}
                          </td>
                          <td
                            class="border texto-cen bg-celda-amarilla pa-1 font-weight-bold"
                          >
                            {{ item.neumaticos_reencauchar }}
                          </td>
                          <td
                            class="border texto-cen bg-celda-azul pa-1 font-weight-bold"
                          >
                            {{ item.neumaticos_proximos_reencauchar }}
                          </td>
                        </tr>
                        <tr
                          v-if="
                            !NivelesRemanenteUnidad ||
                            NivelesRemanenteUnidad.length == 0
                          "
                        >
                          <td
                            class="text-center py-6 grey--text"
                            :colspan="
                              NivelesRemanenteUnidadPosiciones.length + 5
                            "
                          >
                            <v-icon
                              size="24"
                              color="grey lighten-1"
                              class="mr-1"
                              >mdi-clipboard-text-outline</v-icon
                            >
                            No hay datos para remanentes por unidad
                          </td>
                        </tr>
                      </tbody>
                      <tfoot
                        v-if="
                          NivelesRemanenteUnidad &&
                          NivelesRemanenteUnidad.length > 0
                        "
                      >
                        <tr class="table-totals-row">
                          <td
                            class="font-weight-bold text-right pa-2"
                            rowspan="2"
                            :colspan="
                              NivelesRemanenteUnidadPosiciones.length + 2
                            "
                          >
                            TOTAL GENERAL
                          </td>
                          <td
                            class="text-center font-weight-bold pa-2"
                            rowspan="2"
                          >
                            <span class="count-badge count-badge-total">{{
                              ResumenRemanentesUnidad.total_neumaticos
                            }}</span>
                          </td>
                          <td class="text-center font-weight-bold pa-2">
                            <span class="count-badge">{{
                              ResumenRemanentesUnidad.total_neumaticos_reencauchar
                            }}</span>
                          </td>
                          <td class="text-center font-weight-bold pa-2">
                            <span class="count-badge">{{
                              ResumenRemanentesUnidad.neumaticos_proximos_reencauchar
                            }}</span>
                          </td>
                        </tr>
                        <tr class="table-totals-row">
                          <td class="text-center font-weight-bold pa-2">
                            <span class="percent-badge">
                              {{
                                calcularPorcentajes(
                                  ResumenRemanentesUnidad.total_neumaticos_reencauchar,
                                  ResumenRemanentesUnidad.total_neumaticos,
                                )
                              }}
                            </span>
                          </td>
                          <td class="text-center font-weight-bold pa-2">
                            <span class="percent-badge">
                              {{
                                calcularPorcentajes(
                                  ResumenRemanentesUnidad.neumaticos_proximos_reencauchar,
                                  ResumenRemanentesUnidad.total_neumaticos,
                                )
                              }}
                            </span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Neumáticos para servicio de reencauche-->
        <v-row justify="center">
          <v-col lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-tire</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Neumáticos para Servicio de Reencauche
                </span>
                <v-spacer></v-spacer>
                <v-chip
                  v-if="
                    NeumaticosServicioReencauche &&
                    NeumaticosServicioReencauche.length > 0
                  "
                  x-small
                  color="blue darken-2"
                  dark
                  class="font-weight-bold mr-2 d-none d-sm-inline-flex"
                >
                  <v-icon left x-small>mdi-wrench</v-icon>
                  {{ NeumaticosServicioReencauche.length }} Neumáticos
                </v-chip>
              </v-toolbar>

              <!-- Subtítulo descriptivo -->
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span class="text-caption grey--text text--darken-2">
                    Relación de neumáticos que cumplen con los criterios de
                    profundidad para proceso de reencauche
                  </span>
                </div>
              </div>

              <div class="pa-4">
                <div
                  class="table-card-wrapper rounded-lg border overflow-hidden elevation-1"
                >
                  <div class="table-responsive" style="overflow-x: auto">
                    <table class="modern-report-table" style="width: 100%">
                      <thead>
                        <tr>
                          <th style="width: 8%" class="text-center">
                            Vehículo
                          </th>
                          <th style="width: 5%" class="text-center">Pos</th>
                          <th style="width: 9%">Marca</th>
                          <th style="width: 9%">Medida</th>
                          <th style="width: 9%">Modelo</th>
                          <th style="width: 7%" class="text-center">Estado</th>
                          <th style="width: 9%">Serie</th>
                          <th style="width: 6%" class="text-center">1</th>
                          <th style="width: 6%" class="text-center">2</th>
                          <th style="width: 6%" class="text-center">3</th>
                          <th style="width: 6%" class="text-center">NSD</th>
                          <th style="width: 20%">Observaciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in paginatedServicioReencauche"
                          :key="index"
                          class="report-data-row"
                        >
                          <td class="text-center">
                            <span class="plate-badge">{{
                              item.placa || "-"
                            }}</span>
                          </td>
                          <td class="text-center">
                            <span class="pos-badge">{{
                              item.posicion || "-"
                            }}</span>
                          </td>
                          <td
                            class="font-weight-bold text-uppercase"
                            style="color: #1e293b"
                          >
                            {{ item.marca || "-" }}
                          </td>
                          <td>{{ item.medida || "-" }}</td>
                          <td>{{ item.modelo || "-" }}</td>
                          <td class="text-center">
                            <span class="condition-badge">{{
                              item.condicion || "-"
                            }}</span>
                          </td>
                          <td
                            class="font-weight-medium text-caption"
                            style="font-family: monospace"
                          >
                            {{ item.num_serie || "-" }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item.exterior || "-" }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item.medio || "-" }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item.interior || "-" }}
                          </td>
                          <td class="text-center">
                            <span class="nsd-badge">{{
                              item.nsd != null ? item.nsd : "-"
                            }}</span>
                          </td>
                          <td class="observaciones-cell">
                            <span class="text-caption font-weight-medium">{{
                              item.recomendacion || "-"
                            }}</span>
                          </td>
                        </tr>
                        <tr
                          v-if="
                            !NeumaticosServicioReencauche ||
                            NeumaticosServicioReencauche.length == 0
                          "
                        >
                          <td
                            class="text-center py-8 text-body-2 grey--text"
                            colspan="12"
                          >
                            <v-icon size="28" color="success" class="mr-2"
                              >mdi-check-circle-outline</v-icon
                            >
                            No hay neumáticos para servicio de reencauche
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  class="text-center pt-4"
                  v-if="
                    NeumaticosServicioReencauche &&
                    NeumaticosServicioReencauche.length > itemsPerPage50
                  "
                >
                  <v-pagination
                    v-model="pageServicioReencauche"
                    :length="
                      Math.ceil(
                        NeumaticosServicioReencauche.length / itemsPerPage50,
                      )
                    "
                    total-visible="7"
                    color="#243042"
                    class="my-4"
                  ></v-pagination>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Rotaciones de desgastes irregulares-->
        <v-row justify="center">
          <v-col lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-cached</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Rotaciones - Desgastes Irregulares
                </span>
                <v-spacer></v-spacer>
                <v-chip
                  v-if="
                    RotacionesIrregulares && RotacionesIrregulares.length > 0
                  "
                  x-small
                  color="purple darken-2"
                  dark
                  class="font-weight-bold mr-2 d-none d-sm-inline-flex"
                >
                  <v-icon left x-small>mdi-sync</v-icon>
                  {{ RotacionesIrregulares.length }} Neumáticos
                </v-chip>
              </v-toolbar>

              <!-- Subtítulo descriptivo -->
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span class="text-caption grey--text text--darken-2">
                    Neumáticos con desgaste asimétrico o disparidad de hombros
                    que requieren rotación correctiva
                  </span>
                </div>
              </div>

              <div class="pa-4">
                <div
                  class="table-card-wrapper rounded-lg border overflow-hidden elevation-1"
                >
                  <div class="table-responsive" style="overflow-x: auto">
                    <table class="modern-report-table" style="width: 100%">
                      <thead>
                        <tr>
                          <th style="width: 9%" class="text-center">
                            Vehículo
                          </th>
                          <th style="width: 6%" class="text-center">Pos</th>
                          <th style="width: 9%">Marca</th>
                          <th style="width: 9%">Medida</th>
                          <th style="width: 9%">Modelo</th>
                          <th style="width: 8%" class="text-center">Estado</th>
                          <th style="width: 9%">Serie</th>
                          <th style="width: 6%" class="text-center">1</th>
                          <th style="width: 6%" class="text-center">2</th>
                          <th style="width: 6%" class="text-center">NSD</th>
                          <th style="width: 22%">Observaciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(
                            item, index
                          ) in paginatedRotacionesIrregulares"
                          :key="index"
                          class="report-data-row"
                        >
                          <td class="text-center">
                            <span class="plate-badge">{{
                              item.placa || "-"
                            }}</span>
                          </td>
                          <td class="text-center">
                            <span class="pos-badge">{{
                              item.posicion || "-"
                            }}</span>
                          </td>
                          <td
                            class="font-weight-bold text-uppercase"
                            style="color: #1e293b"
                          >
                            {{ item.marca || "-" }}
                          </td>
                          <td>{{ item.medida || "-" }}</td>
                          <td>{{ item.modelo || "-" }}</td>
                          <td class="text-center">
                            <span class="condition-badge">{{
                              item.condicion || "-"
                            }}</span>
                          </td>
                          <td
                            class="font-weight-medium text-caption"
                            style="font-family: monospace"
                          >
                            {{ item.num_serie || "-" }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item.exterior || "-" }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item.interior || "-" }}
                          </td>
                          <td class="text-center">
                            <span class="nsd-badge">{{
                              item.nsd != null ? item.nsd : "-"
                            }}</span>
                          </td>
                          <td class="observaciones-cell">
                            <span class="text-caption font-weight-medium">{{
                              item.td_adicional || "-"
                            }}</span>
                          </td>
                        </tr>
                        <tr
                          v-if="
                            !RotacionesIrregulares ||
                            RotacionesIrregulares.length == 0
                          "
                        >
                          <td
                            class="text-center py-8 text-body-2 grey--text"
                            colspan="11"
                          >
                            <v-icon size="28" color="success" class="mr-2"
                              >mdi-check-circle-outline</v-icon
                            >
                            No hay neumáticos con desgaste irregular
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  class="text-center pt-4"
                  v-if="
                    RotacionesIrregulares &&
                    RotacionesIrregulares.length > itemsPerPage50
                  "
                >
                  <v-pagination
                    v-model="pageRotacionesIrregulares"
                    :length="
                      Math.ceil(RotacionesIrregulares.length / itemsPerPage50)
                    "
                    total-visible="7"
                    color="#243042"
                    class="my-4"
                  ></v-pagination>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Inflado de neumáticos-->
        <v-row justify="center">
          <v-col cols="12" md="6" lg="6">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-3">
                <v-icon left small>mdi-air-filter</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Inflado de Neumáticos
                </span>
              </v-toolbar>
              <div class="chart-subtitle-bar px-4 py-2 d-flex align-center">
                <v-icon x-small color="grey darken-1" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                <span class="text-caption grey--text text--darken-2">
                  Evaluación del estado de inflado (Correcto, Sobreinflado,
                  Bajo)
                </span>
              </div>
              <v-divider></v-divider>
              <div
                class="chart-canvas-container pa-3 pa-md-4 flex-grow-1 d-flex align-center justify-center"
              >
                <canvas
                  ref="elemento"
                  id="pieInflado"
                  style="max-height: 400px; width: 100%"
                ></canvas>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-3">
                <v-icon left small>mdi-gauge</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Presión de Inflado de Neumáticos
                </span>
              </v-toolbar>
              <div class="chart-subtitle-bar px-4 py-2 d-flex align-center">
                <v-icon x-small color="grey darken-1" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                <span class="text-caption grey--text text--darken-2">
                  Distribución por rangos de presión en PSI registrados en
                  inspección
                </span>
              </div>
              <v-divider></v-divider>
              <div
                class="chart-canvas-container pa-3 pa-md-4 flex-grow-1 d-flex align-center justify-center"
              >
                <canvas
                  ref="elemento"
                  id="piePresion"
                  style="max-height: 400px; width: 100%"
                ></canvas>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Neumáticos remanentes medida-->
        <v-row justify="center">
          <v-col lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-ruler-square</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Niveles de Remanente por Medida
                </span>
              </v-toolbar>

              <!-- Subtítulo descriptivo -->
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span class="text-caption grey--text text--darken-2">
                    Profundidad de remanente agrupada por aplicación de vehículo
                    y medidas de neumático
                  </span>
                </div>
              </div>

              <div
                class="pa-4"
                v-for="(item, index1) in NivelesRemanenteMedidaoficial"
                :key="index1"
              >
                <!-- Tabla Matriz de Profundidad por Medida -->
                <div
                  class="table-card-wrapper rounded-lg border overflow-hidden elevation-1 mb-4"
                >
                  <div class="table-responsive" style="overflow-x: auto">
                    <table
                      class="modern-report-table modern-remanente-table"
                      style="width: 100%"
                    >
                      <thead>
                        <tr class="header-group-row">
                          <th
                            class="text-center"
                            colspan="2"
                            style="width: 28%"
                          >
                            <v-icon x-small color="white" class="mr-1"
                              >mdi-tag-outline</v-icon
                            >
                            APLICACIÓN:
                            {{
                              ResumenRemanentesMedida[index1].aplicacion
                                .aplicacion
                            }}
                          </th>
                          <th
                            class="text-center"
                            :colspan="RemanentesMedida[index1].length + 1"
                          >
                            PROFUNDIDAD DE BANDA DE RODAMIENTO EN MILÍMETROS
                          </th>
                        </tr>
                        <tr class="header-leaf-row">
                          <th style="width: 14%" class="text-center">
                            Vehículo
                          </th>
                          <th style="width: 14%" class="text-center">Medida</th>
                          <th
                            style="width: 45px"
                            class="text-center"
                            v-for="(item, index) in RemanentesMedida[index1]"
                            :key="index"
                          >
                            {{ item }}
                          </th>
                          <th style="width: 10%" class="text-center">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in NivelesRemanenteMedida[
                            index1
                          ]"
                          :key="index"
                          class="report-data-row"
                        >
                          <td class="text-center font-weight-medium">
                            {{ item.tipovehiculo }}
                          </td>
                          <td class="text-center font-weight-bold">
                            {{ item.medida }}
                          </td>
                          <td
                            v-for="(item2, index2) in RemanentesMedida[index1]"
                            :key="index2"
                            :class="
                              tdPintarRemanente(
                                item2,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_reencauche,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_proximo,
                              )
                            "
                          >
                            {{ tdValorRemanente(index1, index, item2) }}
                          </td>
                          <td class="text-center font-weight-bold">
                            <span class="count-badge">{{
                              item.total_vehiculo_medidas
                            }}</span>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="table-totals-row">
                          <td colspan="2" class="text-right font-weight-bold">
                            TOTAL
                          </td>
                          <td
                            class="text-center font-weight-bold"
                            v-for="(item, index) in TotalesMedida[index1]"
                            :key="index"
                          >
                            {{ item }}
                          </td>
                          <td class="text-center font-weight-bold">
                            <span class="count-badge count-badge-total">{{
                              TotalDatosMedida[index1]
                            }}</span>
                          </td>
                        </tr>
                        <tr
                          v-if="
                            colspanRemParaReencauche(
                              index1,
                              ResumenRemanentesMedida[index1].aplicacion
                                .rem_reencauche,
                            ) != 0 ||
                            colspanRemProxReencauche(
                              index1,
                              ResumenRemanentesMedida[index1].aplicacion
                                .rem_reencauche,
                              ResumenRemanentesMedida[index1].aplicacion
                                .rem_proximo,
                            ) != 0
                          "
                          class="table-totals-row"
                        >
                          <td
                            class="border texto-cen"
                            colspan="2"
                            rowspan="2"
                          ></td>
                          <td
                            class="border texto-cen font-weight-bold bg-celda-amarilla"
                            v-if="
                              colspanRemParaReencauche(
                                index1,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_reencauche,
                              ) != 0
                            "
                            :colspan="
                              colspanRemParaReencauche(
                                index1,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_reencauche,
                              )
                            "
                          >
                            {{
                              ResumenRemanentesMedida[index1]
                                .neumaticos_reencauchar
                            }}
                          </td>
                          <td
                            class="border texto-cen font-weight-bold bg-celda-azul"
                            v-if="
                              colspanRemProxReencauche(
                                index1,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_reencauche,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_proximo,
                              ) != 0
                            "
                            :colspan="
                              colspanRemProxReencauche(
                                index1,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_reencauche,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_proximo,
                              )
                            "
                          >
                            {{
                              ResumenRemanentesMedida[index1]
                                .neumaticos_proximo_reencauchar
                            }}
                          </td>
                          <td
                            class="border texto-cen"
                            v-if="
                              RemanentesMedida[index1].length -
                                colspanRemParaReencauche(
                                  index1,
                                  ResumenRemanentesMedida[index1].aplicacion
                                    .rem_reencauche,
                                ) !=
                              0
                            "
                            rowspan="2"
                            :colspan="
                              RemanentesMedida[index1].length -
                              colspanRemParaReencauche(
                                index1,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_reencauche,
                              )
                            "
                          ></td>
                        </tr>
                        <tr
                          v-if="
                            colspanRemParaReencauche(
                              index1,
                              ResumenRemanentesMedida[index1].aplicacion
                                .rem_reencauche,
                            ) != 0 ||
                            colspanRemProxReencauche(
                              index1,
                              ResumenRemanentesMedida[index1].aplicacion
                                .rem_reencauche,
                              ResumenRemanentesMedida[index1].aplicacion
                                .rem_proximo,
                            ) != 0
                          "
                          class="table-totals-row"
                        >
                          <td
                            class="border texto-cen font-weight-bold bg-celda-amarilla"
                            v-if="
                              colspanRemParaReencauche(
                                index1,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_reencauche,
                              ) != 0
                            "
                            :colspan="
                              colspanRemParaReencauche(
                                index1,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_reencauche,
                              )
                            "
                          >
                            {{
                              calcularPorcentajes(
                                ResumenRemanentesMedida[index1]
                                  .neumaticos_reencauchar,
                                ResumenRemanentesMedida[index1].total_general,
                              )
                            }}
                          </td>
                          <td
                            class="border texto-cen font-weight-bold bg-celda-azul"
                            v-if="
                              colspanRemProxReencauche(
                                index1,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_reencauche,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_proximo,
                              ) != 0
                            "
                            :colspan="
                              colspanRemProxReencauche(
                                index1,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_reencauche,
                                ResumenRemanentesMedida[index1].aplicacion
                                  .rem_proximo,
                              )
                            "
                          >
                            {{
                              calcularPorcentajes(
                                ResumenRemanentesMedida[index1]
                                  .neumaticos_proximo_reencauchar,
                                ResumenRemanentesMedida[index1].total_general,
                              )
                            }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <!-- Tabla Resumen por Aplicación -->
                <div
                  class="table-card-wrapper rounded-lg border overflow-hidden elevation-1"
                >
                  <div class="table-responsive" style="overflow-x: auto">
                    <table class="modern-report-table" style="width: 100%">
                      <thead>
                        <tr>
                          <th style="width: 25%">Aplicación</th>
                          <th style="width: 15%" class="text-center">Reenc.</th>
                          <th style="width: 15%" class="text-center">
                            Próx. Reenc.
                          </th>
                          <th style="width: 15%" class="text-center">
                            Operativo
                          </th>
                          <th style="width: 15%" class="text-center">Total</th>
                          <th style="width: 15%" class="text-center">
                            Porcentaje
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="report-data-row">
                          <td class="font-weight-bold" style="color: #1e293b">
                            {{
                              ResumenRemanentesMedida[index1].aplicacion
                                .aplicacion
                            }}
                          </td>
                          <td class="text-center">
                            <span class="count-badge bg-celda-amarilla">
                              {{
                                ResumenRemanentesMedida[index1]
                                  .neumaticos_reencauchar
                              }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span class="count-badge bg-celda-azul">
                              {{
                                ResumenRemanentesMedida[index1]
                                  .neumaticos_proximo_reencauchar
                              }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span class="count-badge">
                              {{
                                ResumenRemanentesMedida[index1]
                                  .neumaticos_operativos
                              }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span class="count-badge count-badge-total">
                              {{
                                ResumenRemanentesMedida[index1].total_general
                              }}
                            </span>
                          </td>
                          <td class="text-center font-weight-bold">
                            <span class="percent-badge">
                              {{
                                mostrarPorcentaje(
                                  NivelesRemanenteMedida[index1],
                                )
                              }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="table-totals-row">
                          <td class="font-weight-bold text-right">TOTAL</td>
                          <td class="text-center font-weight-bold">
                            <span class="percent-badge">
                              {{
                                calcularPorcentajes(
                                  ResumenRemanentesMedida[index1]
                                    .neumaticos_reencauchar,
                                  ResumenRemanentesMedida[index1].total_general,
                                )
                              }}
                            </span>
                          </td>
                          <td class="text-center font-weight-bold">
                            <span class="percent-badge">
                              {{
                                calcularPorcentajes(
                                  ResumenRemanentesMedida[index1]
                                    .neumaticos_proximo_reencauchar,
                                  ResumenRemanentesMedida[index1].total_general,
                                )
                              }}
                            </span>
                          </td>
                          <td class="text-center font-weight-bold">
                            <span class="percent-badge">
                              {{
                                calcularPorcentajes(
                                  ResumenRemanentesMedida[index1]
                                    .neumaticos_operativos,
                                  ResumenRemanentesMedida[index1].total_general,
                                )
                              }}
                            </span>
                          </td>
                          <td class="text-center font-weight-bold">
                            <span class="count-badge count-badge-total">
                              {{
                                ResumenRemanentesMedida[index1].total_general
                              }}
                            </span>
                          </td>
                          <td class="text-center font-weight-bold">
                            <span class="percent-badge percent-badge-total">
                              {{
                                mostrarPorcentaje(
                                  NivelesRemanenteMedida[index1],
                                )
                              }}
                            </span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Indice de reencauche y reencauchabilidad-->
        <v-row justify="center">
          <v-col cols="12" md="6" lg="6">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-3">
                <v-icon left small>mdi-cached</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Indicador de Reencauche
                </span>
              </v-toolbar>
              <div class="chart-subtitle-bar px-4 py-2 d-flex align-center">
                <v-icon x-small color="grey darken-1" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                <span class="text-caption grey--text text--darken-2">
                  Proporción entre neumáticos originales y neumáticos con
                  servicio de reencauche
                </span>
              </div>
              <v-divider></v-divider>
              <div
                class="chart-canvas-container pa-3 pa-md-4 flex-grow-1 d-flex align-center justify-center"
              >
                <canvas
                  ref="elemento"
                  id="pieReencauche"
                  style="max-height: 400px; width: 100%"
                ></canvas>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden h-100 d-flex flex-column"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-3">
                <v-icon left small>mdi-chart-bell-curve</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Indicador de Reencauchabilidad
                </span>
              </v-toolbar>
              <div class="chart-subtitle-bar px-4 py-2 d-flex align-center">
                <v-icon x-small color="grey darken-1" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                <span class="text-caption grey--text text--darken-2">
                  Capacidad de los cascos para soportar ciclos sucesivos de
                  reencauche
                </span>
              </div>
              <v-divider></v-divider>
              <div
                class="chart-canvas-container pa-3 pa-md-4 flex-grow-1 d-flex align-center justify-center"
              >
                <canvas
                  ref="elemento"
                  id="barReencauchabilidad"
                  style="max-height: 400px; width: 100%"
                ></canvas>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Rendimiento neumaticos nuevos-->
        <v-row justify="center">
          <v-col lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-speedometer</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Rendimientos de Neumáticos Nuevos
                </span>
              </v-toolbar>

              <!-- Subtítulo descriptivo -->
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span class="text-caption grey--text text--darken-2">
                    Resumen y análisis de rendimientos activos de neumáticos
                    nuevos (Kilómetros y Horas)
                  </span>
                </div>
              </div>

              <div class="pa-4">
                <div
                  class="table-card-wrapper rounded-lg border overflow-hidden elevation-1"
                >
                  <div class="table-responsive" style="overflow-x: auto">
                    <table class="modern-report-table" style="width: 100%">
                      <thead>
                        <tr class="header-group-row">
                          <th colspan="13" class="text-center">
                            RESUMEN PROMEDIOS DE RENDIMIENTOS ACTIVOS
                          </th>
                        </tr>
                      </thead>

                      <!-- COLUMNAS KILOMETROS -->
                      <template v-if="hasRendimientosNuevosKm">
                        <thead>
                          <tr class="header-leaf-row">
                            <th style="width: 9%">Marca</th>
                            <th style="width: 9%">Modelo</th>
                            <th style="width: 9%">Medida</th>
                            <th style="width: 8%" class="text-center">Eje</th>
                            <th style="width: 7%" class="text-center">
                              Condición
                            </th>
                            <th style="width: 6%" class="text-center">
                              Muestra
                            </th>
                            <th style="width: 7%" class="text-center">
                              NSD Inspec.
                            </th>
                            <th style="width: 7%" class="text-center">
                              % Desgaste
                            </th>
                            <th style="width: 9%" class="text-center">
                              Km Recorrido
                            </th>
                            <th style="width: 7%" class="text-center">
                              Km * Mm
                            </th>
                            <th style="width: 9%" class="text-center">
                              Km Proyectado
                            </th>
                            <th style="width: 6%" class="text-center">
                              CPK Actual
                            </th>
                            <th style="width: 7%" class="text-center">
                              CPK Proy.
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              item, index
                            ) in RendimientosNeumaticosNuevos &&
                            RendimientosNeumaticosNuevos.kilometros
                              ? RendimientosNeumaticosNuevos.kilometros
                              : Array.isArray(RendimientosNeumaticosNuevos)
                              ? RendimientosNeumaticosNuevos
                              : []"
                            :key="'nuev_km_' + index"
                            class="report-data-row"
                          >
                            <td class="font-weight-bold" style="color: #1e293b">
                              {{ item.r_marca }}
                            </td>
                            <td>{{ item.r_modelo }}</td>
                            <td>{{ item.r_medida }}</td>
                            <td class="text-center font-weight-medium">
                              {{ item.r_ejes }}
                            </td>
                            <td class="text-center">
                              <span class="condition-badge">{{
                                item.r_condicion
                              }}</span>
                            </td>
                            <td class="text-center font-weight-bold">
                              <span class="count-badge">{{
                                item.r_muestra
                              }}</span>
                            </td>
                            <td class="text-center font-weight-medium">
                              {{ item.r_nsd_prom_inspeccion }}
                            </td>
                            <td class="text-center">
                              <span class="percent-badge"
                                >{{ item.r_porc_desgaste }}%</span
                              >
                            </td>
                            <td class="text-center font-weight-medium">
                              {{
                                item.r_km_prom_recorrido
                                  ? item.r_km_prom_recorrido.toLocaleString()
                                  : 0
                              }}
                            </td>
                            <td class="text-center font-weight-medium">
                              {{
                                item.r_km_mm ? item.r_km_mm.toLocaleString() : 0
                              }}
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              style="color: #0f172a"
                            >
                              {{
                                item.r_km_proyectado
                                  ? item.r_km_proyectado.toLocaleString()
                                  : 0
                              }}
                            </td>
                            <td class="text-center font-weight-medium">
                              ${{ item.r_CPK_actual }}
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              style="color: #15803d"
                            >
                              ${{ item.r_CPK_proyectado }}
                            </td>
                          </tr>
                        </tbody>
                      </template>

                      <!-- COLUMNAS HORAS -->
                      <template v-if="hasRendimientosNuevosHoras">
                        <thead>
                          <tr class="header-leaf-row">
                            <th style="width: 9%">Marca</th>
                            <th style="width: 9%">Modelo</th>
                            <th style="width: 9%">Medida</th>
                            <th style="width: 8%" class="text-center">Eje</th>
                            <th style="width: 7%" class="text-center">
                              Condición
                            </th>
                            <th style="width: 6%" class="text-center">
                              Muestra
                            </th>
                            <th style="width: 7%" class="text-center">
                              NSD Inspec.
                            </th>
                            <th style="width: 7%" class="text-center">
                              % Desgaste
                            </th>
                            <th style="width: 9%" class="text-center">
                              Hrs Recorridas
                            </th>
                            <th style="width: 7%" class="text-center">
                              Hrs * Mm
                            </th>
                            <th style="width: 9%" class="text-center">
                              Hrs Proyectadas
                            </th>
                            <th style="width: 6%" class="text-center">
                              CPH Actual
                            </th>
                            <th style="width: 7%" class="text-center">
                              CPH Proy.
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              item, index
                            ) in RendimientosNeumaticosNuevos &&
                            RendimientosNeumaticosNuevos.horas
                              ? RendimientosNeumaticosNuevos.horas
                              : []"
                            :key="'nuev_hr_' + index"
                            class="report-data-row"
                          >
                            <td class="font-weight-bold" style="color: #1e293b">
                              {{ item.r_marca }}
                            </td>
                            <td>{{ item.r_modelo }}</td>
                            <td>{{ item.r_medida }}</td>
                            <td class="text-center font-weight-medium">
                              {{ item.r_ejes }}
                            </td>
                            <td class="text-center">
                              <span class="condition-badge">{{
                                item.r_condicion
                              }}</span>
                            </td>
                            <td class="text-center font-weight-bold">
                              <span class="count-badge">{{
                                item.r_muestra
                              }}</span>
                            </td>
                            <td class="text-center font-weight-medium">
                              {{ item.r_nsd_prom_inspeccion }}
                            </td>
                            <td class="text-center">
                              <span class="percent-badge"
                                >{{ item.r_porc_desgaste }}%</span
                              >
                            </td>
                            <td class="text-center font-weight-medium">
                              {{
                                item.r_km_prom_recorrido
                                  ? item.r_km_prom_recorrido.toLocaleString()
                                  : 0
                              }}
                            </td>
                            <td class="text-center font-weight-medium">
                              {{
                                item.r_km_mm ? item.r_km_mm.toLocaleString() : 0
                              }}
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              style="color: #0f172a"
                            >
                              {{
                                item.r_km_proyectado
                                  ? item.r_km_proyectado.toLocaleString()
                                  : 0
                              }}
                            </td>
                            <td class="text-center font-weight-medium">
                              ${{ item.r_CPK_actual }}
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              style="color: #15803d"
                            >
                              ${{ item.r_CPK_proyectado }}
                            </td>
                          </tr>
                        </tbody>
                      </template>

                      <tbody v-if="!hasRendimientosNuevos">
                        <tr>
                          <td
                            class="text-center py-8 text-body-2 grey--text"
                            colspan="13"
                          >
                            <v-icon
                              size="24"
                              color="grey lighten-1"
                              class="mr-1"
                              >mdi-speedometer-slow</v-icon
                            >
                            No existen datos sobre rendimientos de neumáticos
                            nuevos
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  class="text-center pt-4"
                  v-if="
                    RendimientosNeumaticosNuevos &&
                    RendimientosNeumaticosNuevos.length > itemsPerPage50
                  "
                >
                  <v-pagination
                    v-model="pageRendimientosNuevos"
                    :length="
                      Math.ceil(
                        RendimientosNeumaticosNuevos.length / itemsPerPage50,
                      )
                    "
                    total-visible="7"
                    color="#243042"
                    class="my-4"
                  ></v-pagination>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Rendimiento neumaticos reencauchados-->
        <v-row justify="center">
          <v-col lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-speedometer-slow</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Rendimientos de Neumáticos Reencauchados
                </span>
              </v-toolbar>

              <!-- Subtítulo descriptivo -->
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span class="text-caption grey--text text--darken-2">
                    Resumen y análisis de rendimientos de neumáticos
                    reencauchados (Kilómetros y Horas)
                  </span>
                </div>
              </div>

              <div class="pa-4">
                <div
                  class="table-card-wrapper rounded-lg border overflow-hidden elevation-1"
                >
                  <div class="table-responsive" style="overflow-x: auto">
                    <table class="modern-report-table" style="width: 100%">
                      <thead>
                        <tr class="header-group-row">
                          <th colspan="13" class="text-center">
                            RESUMEN PROMEDIOS DE RENDIMIENTOS ACTIVOS
                          </th>
                        </tr>
                      </thead>

                      <!-- COLUMNAS KILOMETROS -->
                      <template v-if="hasRendimientosReencauchadosKm">
                        <thead>
                          <tr class="header-leaf-row">
                            <th style="width: 8%" class="text-center">
                              Condición
                            </th>
                            <th style="width: 11%">Empresa Reencauche</th>
                            <th style="width: 8%" class="text-center">Eje</th>
                            <th style="width: 9%">Medida</th>
                            <th style="width: 10%">Diseño Reencauche</th>
                            <th style="width: 6%" class="text-center">
                              Muestra
                            </th>
                            <th style="width: 7%" class="text-center">
                              NSD Inspec.
                            </th>
                            <th style="width: 7%" class="text-center">
                              % Desgaste
                            </th>
                            <th style="width: 9%" class="text-center">
                              Km Recorrido
                            </th>
                            <th style="width: 7%" class="text-center">
                              Km * Mm
                            </th>
                            <th style="width: 9%" class="text-center">
                              Km Proyectado
                            </th>
                            <th style="width: 6%" class="text-center">
                              CPK Actual
                            </th>
                            <th style="width: 7%" class="text-center">
                              CPK Proy.
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              item, index
                            ) in RendimientosNeumaticosReencauchados &&
                            RendimientosNeumaticosReencauchados.kilometros
                              ? RendimientosNeumaticosReencauchados.kilometros
                              : Array.isArray(
                                  RendimientosNeumaticosReencauchados,
                                )
                              ? RendimientosNeumaticosReencauchados
                              : []"
                            :key="'reen_km_' + index"
                            class="report-data-row"
                          >
                            <td class="text-center">
                              <span class="condition-badge">{{
                                item.r_condicion
                              }}</span>
                            </td>
                            <td class="font-weight-bold" style="color: #1e293b">
                              {{ item.r_empresa }}
                            </td>
                            <td class="text-center font-weight-medium">
                              {{ item.r_ejes }}
                            </td>
                            <td>{{ item.r_medida }}</td>
                            <td>{{ item.r_disenio_reencauche }}</td>
                            <td class="text-center font-weight-bold">
                              <span class="count-badge">{{
                                item.r_muestra
                              }}</span>
                            </td>
                            <td class="text-center font-weight-medium">
                              {{ item.r_nsd_prom_inspeccion }}
                            </td>
                            <td class="text-center">
                              <span class="percent-badge"
                                >{{ item.r_porc_desgaste }}%</span
                              >
                            </td>
                            <td class="text-center font-weight-medium">
                              {{
                                item.r_km_prom_recorrido
                                  ? item.r_km_prom_recorrido.toLocaleString()
                                  : 0
                              }}
                            </td>
                            <td class="text-center font-weight-medium">
                              {{
                                item.r_km_mm ? item.r_km_mm.toLocaleString() : 0
                              }}
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              style="color: #0f172a"
                            >
                              {{
                                item.r_km_proyectado
                                  ? item.r_km_proyectado.toLocaleString()
                                  : 0
                              }}
                            </td>
                            <td class="text-center font-weight-medium">
                              ${{ item.r_CPK_actual }}
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              style="color: #15803d"
                            >
                              ${{ item.r_CPK_proyectado }}
                            </td>
                          </tr>
                        </tbody>
                      </template>

                      <!-- COLUMNAS HORAS -->
                      <template v-if="hasRendimientosReencauchadosHoras">
                        <thead>
                          <tr class="header-leaf-row">
                            <th style="width: 8%" class="text-center">
                              Condición
                            </th>
                            <th style="width: 11%">Empresa Reencauche</th>
                            <th style="width: 8%" class="text-center">Eje</th>
                            <th style="width: 9%">Medida</th>
                            <th style="width: 10%">Diseño Reencauche</th>
                            <th style="width: 6%" class="text-center">
                              Muestra
                            </th>
                            <th style="width: 7%" class="text-center">
                              NSD Inspec.
                            </th>
                            <th style="width: 7%" class="text-center">
                              % Desgaste
                            </th>
                            <th style="width: 9%" class="text-center">
                              Hrs Recorridas
                            </th>
                            <th style="width: 7%" class="text-center">
                              Hrs * Mm
                            </th>
                            <th style="width: 9%" class="text-center">
                              Hrs Proyectadas
                            </th>
                            <th style="width: 6%" class="text-center">
                              CPH Actual
                            </th>
                            <th style="width: 7%" class="text-center">
                              CPH Proy.
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              item, index
                            ) in RendimientosNeumaticosReencauchados &&
                            RendimientosNeumaticosReencauchados.horas
                              ? RendimientosNeumaticosReencauchados.horas
                              : []"
                            :key="'reen_hr_' + index"
                            class="report-data-row"
                          >
                            <td class="text-center">
                              <span class="condition-badge">{{
                                item.r_condicion
                              }}</span>
                            </td>
                            <td class="font-weight-bold" style="color: #1e293b">
                              {{ item.r_empresa }}
                            </td>
                            <td class="text-center font-weight-medium">
                              {{ item.r_ejes }}
                            </td>
                            <td>{{ item.r_medida }}</td>
                            <td>{{ item.r_disenio_reencauche }}</td>
                            <td class="text-center font-weight-bold">
                              <span class="count-badge">{{
                                item.r_muestra
                              }}</span>
                            </td>
                            <td class="text-center font-weight-medium">
                              {{ item.r_nsd_prom_inspeccion }}
                            </td>
                            <td class="text-center">
                              <span class="percent-badge"
                                >{{ item.r_porc_desgaste }}%</span
                              >
                            </td>
                            <td class="text-center font-weight-medium">
                              {{
                                item.r_km_prom_recorrido
                                  ? item.r_km_prom_recorrido.toLocaleString()
                                  : 0
                              }}
                            </td>
                            <td class="text-center font-weight-medium">
                              {{
                                item.r_km_mm ? item.r_km_mm.toLocaleString() : 0
                              }}
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              style="color: #0f172a"
                            >
                              {{
                                item.r_km_proyectado
                                  ? item.r_km_proyectado.toLocaleString()
                                  : 0
                              }}
                            </td>
                            <td class="text-center font-weight-medium">
                              ${{ item.r_CPK_actual }}
                            </td>
                            <td
                              class="text-center font-weight-bold"
                              style="color: #15803d"
                            >
                              ${{ item.r_CPK_proyectado }}
                            </td>
                          </tr>
                        </tbody>
                      </template>

                      <tbody v-if="!hasRendimientosReencauchados">
                        <tr>
                          <td
                            class="text-center py-8 text-body-2 grey--text"
                            colspan="13"
                          >
                            <v-icon
                              size="24"
                              color="grey lighten-1"
                              class="mr-1"
                              >mdi-speedometer-slow</v-icon
                            >
                            No existen datos sobre rendimientos de neumáticos
                            reencauchados
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  class="text-center pt-4"
                  v-if="
                    RendimientosNeumaticosReencauchados &&
                    RendimientosNeumaticosReencauchados.length > itemsPerPage50
                  "
                >
                  <v-pagination
                    v-model="pageRendimientosReencauchados"
                    :length="
                      Math.ceil(
                        RendimientosNeumaticosReencauchados.length /
                          itemsPerPage50,
                      )
                    "
                    total-visible="7"
                    color="#243042"
                    class="my-4"
                  ></v-pagination>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Inspecciones-->
        <v-row justify="center">
          <v-col lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-clipboard-check-outline</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Inspecciones
                </span>
                <v-spacer></v-spacer>
                <v-chip
                  v-if="Inspecciones && Inspecciones.length > 0"
                  x-small
                  color="teal darken-2"
                  dark
                  class="font-weight-bold mr-2 d-none d-sm-inline-flex"
                >
                  <v-icon left x-small>mdi-clipboard-list</v-icon>
                  {{ Inspecciones.length }} Inspecciones
                </v-chip>
              </v-toolbar>

              <!-- Subtítulo descriptivo -->
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span class="text-caption grey--text text--darken-2">
                    Detalle técnico por vehículo evaluado: datos de presión,
                    estado de válvula, remanentes por posición y observaciones
                  </span>
                </div>
              </div>

              <div class="pa-4">
                <div
                  class="table-card-wrapper rounded-lg border overflow-hidden elevation-1 mb-5"
                  v-for="(item, index) in paginatedInspecciones"
                  :key="index"
                >
                  <!-- Barra de metadatos del vehículo inspeccionado -->
                  <div
                    class="inspection-header-bar px-4 py-3 d-flex align-center justify-space-between flex-wrap"
                  >
                    <!-- Información del vehículo -->
                    <div
                      class="d-flex align-center flex-wrap my-1"
                      style="gap: 8px"
                    >
                      <!-- Badge Placa -->
                      <div class="inspection-badge-square highlight-plate">
                        <v-icon color="grey lighten-3" size="18" class="mr-1"
                          >mdi-truck</v-icon
                        >
                        <div class="badge-content">
                          <span class="badge-label">PLACA</span>
                          <span class="badge-value plate-value">{{
                            item.placa
                          }}</span>
                        </div>
                      </div>

                      <!-- Badge Tipo -->
                      <div
                        class="inspection-badge-square"
                        v-if="item.tipovehiculo"
                      >
                        <div class="badge-content">
                          <span class="badge-label">TIPO</span>
                          <span class="badge-value text-uppercase">{{
                            item.tipovehiculo
                          }}</span>
                        </div>
                      </div>

                      <!-- Badge Marca -->
                      <div
                        class="inspection-badge-square"
                        v-if="item.marcavehiculo"
                      >
                        <div class="badge-content">
                          <span class="badge-label">MARCA</span>
                          <span class="badge-value">{{
                            item.marcavehiculo
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <!-- Métricas destacadas: Fecha y Kilometraje -->
                    <div
                      class="d-flex align-center flex-wrap my-1"
                      style="gap: 10px"
                    >
                      <!-- Badge Fecha de Inspección -->
                      <div class="inspection-badge-square highlight-date">
                        <div class="badge-icon-box bg-blue-subtle mr-2">
                          <v-icon size="18" color="blue lighten-2"
                            >mdi-calendar-check</v-icon
                          >
                        </div>
                        <div class="badge-content">
                          <span class="badge-label text-blue-light"
                            >FECHA INSPECCIÓN</span
                          >
                          <span class="badge-value text-date-value">{{
                            item.fecha_inspeccion
                          }}</span>
                        </div>
                      </div>

                      <!-- Badge Kilometraje / Inspección -->
                      <div class="inspection-badge-square highlight-km">
                        <div class="badge-icon-box bg-amber-subtle mr-2">
                          <v-icon size="20" color="amber lighten-1"
                            >mdi-speedometer</v-icon
                          >
                        </div>
                        <div class="badge-content">
                          <span class="badge-label text-amber-light">
                            {{
                              item.tipo_costo_abreviatura
                                ? item.tipo_costo_abreviatura
                                : "KM"
                            }}
                            INSPEC.
                          </span>
                          <span class="badge-value text-km-value">{{
                            item.km_inspeccion
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive" style="overflow-x: auto">
                    <table class="modern-report-table" style="width: 100%">
                      <thead>
                        <tr class="header-group-row">
                          <th style="width: 4%" class="text-center" rowspan="2">
                            Pos
                          </th>
                          <th style="width: 8%" rowspan="2">Marca</th>
                          <th style="width: 8%" rowspan="2">Medida</th>
                          <th style="width: 8%" rowspan="2">Modelo</th>
                          <th style="width: 6%" class="text-center" rowspan="2">
                            Estado
                          </th>
                          <th style="width: 8%" rowspan="2">Diseño Reenc.</th>
                          <th style="width: 9%" rowspan="2">Empresa Reenc.</th>
                          <th style="width: 8%" class="text-center" rowspan="2">
                            Serie
                          </th>
                          <th style="width: 9%" class="text-center" colspan="3">
                            Válvula
                          </th>
                          <th style="width: 8%" class="text-center" colspan="2">
                            Presión
                          </th>
                          <th style="width: 6%" class="text-center" rowspan="2">
                            Estado
                          </th>
                          <th
                            style="width: 12%"
                            class="text-center"
                            colspan="5"
                          >
                            NSD
                          </th>
                          <th style="width: 16%" rowspan="2">Recomendación</th>
                        </tr>
                        <tr class="header-leaf-row">
                          <th style="width: 3%" class="text-center">Tapa</th>
                          <th style="width: 3%" class="text-center">Inacc.</th>
                          <th style="width: 3%" class="text-center">Malog.</th>
                          <th style="width: 4%" class="text-center">Actual</th>
                          <th style="width: 4%" class="text-center">Recom.</th>
                          <th style="width: 2%" class="text-center">Orig.</th>
                          <th style="width: 2%" class="text-center">1</th>
                          <th style="width: 2%" class="text-center">2</th>
                          <th style="width: 2%" class="text-center">3</th>
                          <th style="width: 3%" class="text-center">NSD Min</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item2, index2) in item.detalle"
                          :key="index2"
                          class="report-data-row"
                        >
                          <td class="text-center">
                            <span class="pos-badge">{{ item2.posicion }}</span>
                          </td>
                          <td class="font-weight-bold" style="color: #1e293b">
                            {{ item2.marcaneumatico }}
                          </td>
                          <td>{{ item2.medidaneumatico }}</td>
                          <td>{{ item2.modeloneumatico }}</td>
                          <td class="text-center">
                            <span class="condition-badge">{{
                              item2.condicion
                            }}</span>
                          </td>
                          <td>{{ item2.disenioneumatico }}</td>
                          <td>{{ item2.razon_social }}</td>
                          <td
                            class="text-center font-weight-medium text-caption"
                            style="font-family: monospace"
                          >
                            {{ item2.num_serie }}
                          </td>
                          <td class="text-center">{{ item2.valvula }}</td>
                          <td class="text-center">{{ item2.accesibilidad }}</td>
                          <td class="text-center">{{ item2.malogrado }}</td>
                          <td class="text-center font-weight-bold">
                            {{ item2.presionactual }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item2.presion_recomendada }}
                          </td>
                          <td class="text-center">
                            <span class="condition-badge">{{
                              item2.estadopresion
                            }}</span>
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item2.remanente_original }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item2.exterior }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item2.medio }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item2.interior }}
                          </td>
                          <td class="text-center font-weight-bold">
                            <span class="nsd-badge">{{
                              item2.nsk_minimo
                            }}</span>
                          </td>
                          <td class="observaciones-cell">
                            <span class="text-caption font-weight-medium">{{
                              item2.recomendacion || "-"
                            }}</span>
                          </td>
                        </tr>
                        <tr v-if="!item.detalle || item.detalle.length == 0">
                          <td class="text-center py-6 grey--text" colspan="20">
                            No hay neumáticos inspeccionados para este vehículo
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  class="text-center pt-4"
                  v-if="
                    Inspecciones &&
                    Inspecciones.length > itemsPerPageInspecciones
                  "
                >
                  <v-pagination
                    v-model="pageInspecciones"
                    :length="
                      Math.ceil(Inspecciones.length / itemsPerPageInspecciones)
                    "
                    total-visible="7"
                    color="#243042"
                    class="my-4"
                  ></v-pagination>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Costo por kilometros-->
        <v-row justify="center">
          <v-col cols="12" lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-currency-usd</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Costo por Kilómetro / Hora
                </span>
              </v-toolbar>
              <div class="chart-subtitle-bar px-4 py-2 d-flex align-center">
                <v-icon x-small color="grey darken-1" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                <span class="text-caption grey--text text--darken-2">
                  Evolución y comportamiento del costo operativo por distancia
                  recorrida y horas de trabajo
                </span>
              </div>
              <v-divider></v-divider>
              <div class="pa-4">
                <IndicadorCosto
                  :CostoPorKilometro="CostoPorKilometro"
                  :MesesCostoPorKilometro="MesesCostoPorKilometro"
                />
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!--Perdidas por scrap-->
        <v-row justify="center">
          <v-col lg="12">
            <v-card
              class="dashboard-chart-card rounded-lg elevation-2 overflow-hidden mb-4"
            >
              <v-toolbar height="54" color="#243042" dark flat class="px-4">
                <v-icon left small>mdi-currency-usd-off</v-icon>
                <span class="text-subtitle-1 font-weight-bold">
                  Pérdidas por Scrap
                </span>
                <v-spacer></v-spacer>
                <v-chip
                  v-if="PerdidasPorScrap && PerdidasPorScrap.length > 0"
                  x-small
                  color="red darken-2"
                  dark
                  class="font-weight-bold mr-2 d-none d-sm-inline-flex"
                >
                  <v-icon left x-small>mdi-cash-minus</v-icon>
                  {{ PerdidasPorScrap.length }} Neumáticos
                </v-chip>
              </v-toolbar>

              <!-- Subtítulo descriptivo -->
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center">
                  <v-icon x-small color="grey darken-1" class="mr-1"
                    >mdi-information-outline</v-icon
                  >
                  <span class="text-caption grey--text text--darken-2">
                    Valorización económica del remanente desaprovechado y costo
                    de pérdida financiera por retiro prematuro
                  </span>
                </div>
              </div>

              <div class="pa-4">
                <div
                  class="table-card-wrapper rounded-lg border overflow-hidden elevation-1"
                >
                  <div class="table-responsive" style="overflow-x: auto">
                    <table class="modern-report-table" style="width: 100%">
                      <thead>
                        <tr>
                          <th style="width: 8%" class="text-center">
                            N° Serie
                          </th>
                          <th style="width: 8%" class="text-center">
                            Serie Cliente
                          </th>
                          <th style="width: 8%">Marca</th>
                          <th style="width: 8%">Modelo</th>
                          <th style="width: 8%">Medida</th>
                          <th style="width: 8%" class="text-center">
                            Condición
                          </th>
                          <th style="width: 8%" class="text-center">
                            Fecha Scrap
                          </th>
                          <th style="width: 10%">Motivo Scrap</th>
                          <th style="width: 6%" class="text-center">
                            Rem. Orig.
                          </th>
                          <th style="width: 6%" class="text-center">
                            Rem. Final
                          </th>
                          <th style="width: 6%" class="text-center">
                            Rem. Límite
                          </th>
                          <th style="width: 8%" class="text-center">
                            Costo ($)
                          </th>
                          <th style="width: 8%" class="text-center">
                            Costo Pérdida ($)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in paginatedPerdidasScrap"
                          :key="index"
                          class="report-data-row"
                        >
                          <td
                            class="text-center font-weight-medium text-caption"
                            style="font-family: monospace"
                          >
                            {{ item.num_serie }}
                          </td>
                          <td
                            class="text-center font-weight-medium text-caption"
                            style="font-family: monospace"
                          >
                            {{ item.serie_cliente || "-" }}
                          </td>
                          <td
                            class="font-weight-bold text-uppercase"
                            style="color: #1e293b"
                          >
                            {{ item.marca }}
                          </td>
                          <td>{{ item.modelo }}</td>
                          <td>{{ item.medida }}</td>
                          <td class="text-center">
                            <span class="condition-badge">{{
                              item.condicion
                            }}</span>
                          </td>
                          <td
                            class="text-center font-weight-medium text-caption"
                          >
                            {{ item.fecha_scrap }}
                          </td>
                          <td class="font-weight-medium" style="color: #334155">
                            {{ item.motivo }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item.remanente_original }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item.remanente_final }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ item.remanente_limite }}
                          </td>
                          <td
                            class="text-center font-weight-bold"
                            style="color: #0f172a"
                          >
                            ${{ item.costo }}
                          </td>
                          <td
                            class="text-center font-weight-bold"
                            style="color: #dc2626"
                          >
                            ${{ item.costo_perdido }}
                          </td>
                        </tr>
                        <tr
                          v-if="
                            !PerdidasPorScrap || PerdidasPorScrap.length == 0
                          "
                        >
                          <td
                            class="text-center py-8 text-body-2 grey--text"
                            colspan="13"
                          >
                            <v-icon size="24" color="success" class="mr-1"
                              >mdi-check-circle-outline</v-icon
                            >
                            No hay datos para pérdidas por scrap
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  class="text-center pt-4"
                  v-if="
                    PerdidasPorScrap && PerdidasPorScrap.length > itemsPerPage50
                  "
                >
                  <v-pagination
                    v-model="pagePerdidasScrap"
                    :length="
                      Math.ceil(PerdidasPorScrap.length / itemsPerPage50)
                    "
                    total-visible="7"
                    color="#243042"
                    class="my-4"
                  ></v-pagination>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <!-- Dialog Modal para Selección de Secciones al Exportar -->
      <v-dialog
        v-model="dialogSeccionesExportar"
        max-width="700px"
        persistent
        scrollable
        transition="dialog-transition"
      >
        <v-card class="overflow-hidden">
          <!-- Header con degradado premium -->
          <div
            class="pa-4 primary darken-2 white--text d-flex align-center justify-space-between"
            style="
              background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
            "
          >
            <div>
              <div class="text-h6 font-weight-bold white--text">
                Selección de Secciones a Exportar
              </div>
              <div
                class="caption text--lighten-3 blue-grey--text text--lighten-4"
              >
                Elija los componentes e índices que se incluirán en el reporte
                PDF
              </div>
            </div>
            <v-btn icon dark @click="dialogSeccionesExportar = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <!-- Barra de acciones y estado -->
          <div
            class="px-5 py-3 grey lighten-4 border-bottom d-flex align-center justify-space-between flex-wrap gap-2"
          >
            <div class="d-flex align-center">
              <v-chip color="primary" class="font-weight-bold mr-2" small label>
                <v-icon left x-small>mdi-check-all</v-icon>
                {{ seccionesSeleccionadas.length }} de 12 secciones
              </v-chip>
              <span class="caption text--secondary hidden-xs-only">
                {{
                  seccionesSeleccionadas.length === 12
                    ? "Todas las secciones incluidas"
                    : "Selección personalizada"
                }}
              </span>
            </div>
            <div class="d-flex align-center">
              <v-btn
                text
                x-small
                :color="todasSeccionesSeleccionadas ? 'error' : 'primary'"
                class="font-weight-bold"
                @click="toggleSeleccionarTodas()"
              >
                <v-icon left x-small>{{
                  todasSeccionesSeleccionadas
                    ? "mdi-checkbox-multiple-blank-outline"
                    : "mdi-checkbox-multiple-marked-outline"
                }}</v-icon>
                {{
                  todasSeccionesSeleccionadas
                    ? "Deseleccionar todo"
                    : "Seleccionar todo"
                }}
              </v-btn>
            </div>
          </div>

          <v-card-text
            class="pa-5"
            style="max-height: 65vh; background-color: #f8fafc"
          >
            <v-row dense>
              <v-col
                cols="12"
                v-for="sec in seccionesDisponibles"
                :key="sec.id"
                class="mb-2"
              >
                <div
                  class="seccion-card-grupo rounded-lg border bg-white elevation-1 pa-3"
                  style="cursor: pointer; user-select: none"
                  @click="toggleSeccion(sec.id)"
                  :class="{
                    'seccion-simple-selected': seccionesSeleccionadas.includes(
                      sec.id,
                    ),
                  }"
                >
                  <div class="d-flex align-center">
                    <v-icon
                      :color="
                        seccionesSeleccionadas.includes(sec.id)
                          ? 'primary'
                          : 'grey darken-1'
                      "
                      class="mr-2"
                    >
                      {{
                        seccionesSeleccionadas.includes(sec.id)
                          ? "mdi-checkbox-marked"
                          : "mdi-checkbox-blank-outline"
                      }}
                    </v-icon>
                    <span
                      class="body-2 grey--text text--darken-3 font-weight-bold"
                    >
                      {{ sec.titulo }}
                    </span>
                  </div>
                  <div
                    v-if="sec.subsecciones && sec.subsecciones.length"
                    class="pl-8 pt-2"
                  >
                    <div
                      class="caption grey--text text--darken-1 font-weight-medium mb-1"
                    >
                      Contenido incluido:
                    </div>
                    <div class="d-flex flex-wrap">
                      <v-chip
                        v-for="(sub, i) in sec.subsecciones"
                        :key="i"
                        x-small
                        label
                        color="grey lighten-3"
                        class="mr-1 mb-1 grey--text text--darken-2"
                      >
                        {{ sub }}
                      </v-chip>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="px-5 py-3 white">
            <div class="caption grey--text text--darken-1 d-flex align-center">
              <v-icon x-small color="grey" class="mr-1"
                >mdi-information-outline</v-icon
              >
              <span
                >Solo las secciones marcadas serán generadas en el PDF
                final</span
              >
            </div>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="grey darken-2"
              class="px-4"
              @click="dialogSeccionesExportar = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="error"
              class="px-6 rounded-lg elevation-2 font-weight-bold"
              :disabled="seccionesSeleccionadas.length === 0"
              @click="confirmarExportarPDF"
            >
              Exportar PDF
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card class="pa-5">
          <v-card-title>
            <span class="text-h5">Desea eliminar esta recomendación ? </span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-textarea
                    autocomplete="recomendacion"
                    label="Recomendación"
                    v-model="recomendacion.descripcion"
                    readonly
                    rows="2"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              @click="
                dialog = false;
                recomendacion = { id: null, descripcion: '' };
              "
            >
              Cerrar
            </v-btn>
            <v-btn color="info" @click="confirmar()"> Eliminar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Visor del PDF generado -->
      <v-dialog
        v-model="dialogPDF"
        persistent
        max-width="85%"
        transition="dialog-transition"
      >
        <v-card class="rounded-lg overflow-hidden">
          <v-toolbar color="#243042" dark dense flat>
            <v-icon left>mdi-file-pdf-box</v-icon>
            <v-toolbar-title class="text-subtitle-1 font-weight-bold">
              Reporte Consolidado (PDF)
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon small @click="cerrarVisor" class="mr-n2">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-4">
            <!-- iframe del PDF -->
            <div
              v-if="ver_iframe && pdfUrl"
              class="rounded-lg overflow-hidden border"
              style="border: 1px solid #e0e0e0"
            >
              <iframe
                id="ifrm"
                :src="pdfUrl"
                style="width: 100%; height: 75vh; border: none; display: block"
              ></iframe>
            </div>
          </v-card-text>

          <v-card-actions class="px-4 pb-4 pt-0">
            <v-spacer></v-spacer>
            <v-btn text color="grey darken-1" @click="cerrarVisor">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialogo Enviar Reporte Consolidado -->
      <v-dialog
        v-model="dialog_enviar_pdf"
        persistent
        max-width="620px"
        transition="dialog-transition"
      >
        <v-form ref="form2" enctype="multipart/form-data">
          <v-card
            class="rounded-xl overflow-hidden elevation-10 enviar-reporte-card"
          >
            <!-- Header moderno -->
            <v-toolbar height="58" color="#243042" dark flat class="px-4">
              <v-icon left>mdi-send-circle-outline</v-icon>
              <span class="text-subtitle-1 font-weight-bold">
                Enviar Reporte Consolidado
              </span>
              <v-spacer></v-spacer>
              <v-chip
                x-small
                color="white"
                text-color="secondary"
                class="font-weight-bold mr-2"
              >
                Aprobación
              </v-chip>
              <v-btn icon small @click="cerrardialog" class="mr-n2">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text class="pa-5" style="background-color: #f8fafc">
              <!-- Alerta de saludo y confirmación estilizada -->
              <div
                class="send-report-alert pa-3 mb-4 rounded-lg d-flex align-center"
              >
                <div class="send-alert-icon-wrap mr-3">
                  <v-icon color="primary" small
                    >mdi-account-check-outline</v-icon
                  >
                </div>
                <div class="text-body-2 text--primary">
                  Hola <strong class="primary--text">{{ nombreusuario }}</strong
                  >, por favor confirma el envío de este reporte para su
                  respectiva aprobación por el supervisor.
                </div>
              </div>

              <!-- Card con detalles del reporte -->
              <div
                class="summary-detail-box pa-4 rounded-lg border bg-white mb-4"
              >
                <div class="d-flex align-center mb-3">
                  <v-icon small color="secondary" class="mr-2"
                    >mdi-file-document-check-outline</v-icon
                  >
                  <span class="text-subtitle-2 font-weight-bold text--primary">
                    Detalles del Reporte a Enviar
                  </span>
                </div>
                <v-divider class="mb-3"></v-divider>

                <div class="d-flex flex-column" style="gap: 8px">
                  <div
                    class="d-flex align-center justify-space-between flex-wrap py-1"
                  >
                    <span
                      class="caption font-weight-medium grey--text text--darken-1 d-flex align-center"
                    >
                      <v-icon x-small color="grey darken-1" class="mr-1"
                        >mdi-domain</v-icon
                      >
                      Cliente:
                    </span>
                    <span
                      class="body-2 font-weight-bold text--primary text-right"
                    >
                      {{ Cliente.razon_social }}
                    </span>
                  </div>

                  <div
                    class="d-flex align-center justify-space-between flex-wrap py-1 border-top-light"
                  >
                    <span
                      class="caption font-weight-medium grey--text text--darken-1 d-flex align-center"
                    >
                      <v-icon x-small color="grey darken-1" class="mr-1"
                        >mdi-calendar</v-icon
                      >
                      Año de reporte:
                    </span>
                    <v-chip
                      x-small
                      color="grey lighten-3"
                      class="font-weight-bold grey--text text--darken-3"
                    >
                      {{ ItemSelect.year }}
                    </v-chip>
                  </div>

                  <div
                    class="d-flex align-center justify-space-between flex-wrap py-1 border-top-light"
                  >
                    <span
                      class="caption font-weight-medium grey--text text--darken-1 d-flex align-center"
                    >
                      <v-icon x-small color="grey darken-1" class="mr-1"
                        >mdi-calendar-range</v-icon
                      >
                      Periodo / Meses:
                    </span>
                    <div
                      class="d-inline-flex align-center tracking-period-badge px-2 py-1 rounded-pill"
                    >
                      <span class="caption font-weight-bold">
                        {{ obtenerNombreMes(ItemSelect.month1) }}
                        <template
                          v-if="ItemSelect.month1 !== ItemSelect.month2"
                        >
                          &nbsp;a {{ obtenerNombreMes(ItemSelect.month2) }}
                        </template>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Campo de respuesta si existen comentarios de meses rechazados -->
              <div v-if="comentariosPorReporte.length > 0" class="mb-4">
                <div class="d-flex align-center mb-2">
                  <v-icon small color="primary" class="mr-2"
                    >mdi-message-reply-text-outline</v-icon
                  >
                  <span class="text-subtitle-2 font-weight-bold text--primary">
                    Respuesta a las Observaciones
                  </span>
                  <span class="error--text ml-1">*</span>
                </div>
                <v-textarea
                  outlined
                  dense
                  v-model="comentario"
                  :rules="[
                    (v) => !!v || 'La respuesta o recomendación es requerida',
                  ]"
                  rows="3"
                  hide-details="auto"
                  background-color="white"
                  placeholder="Escribe detalladamente las acciones o respuestas a las observaciones..."
                  class="field-custom"
                ></v-textarea>
              </div>

              <!-- Listado de Observaciones por mes rechazado -->
              <div class="mt-4" v-if="comentariosPorReporte.length > 0">
                <div class="d-flex align-center justify-space-between mb-2">
                  <div
                    class="text-subtitle-2 font-weight-bold d-flex align-center error--text"
                  >
                    <v-icon small color="error" class="mr-1"
                      >mdi-alert-circle-outline</v-icon
                    >
                    Observaciones previas registradas
                  </div>
                  <v-chip
                    x-small
                    color="error lighten-5"
                    text-color="error"
                    class="font-weight-bold"
                  >
                    Revisión requerida
                  </v-chip>
                </div>
                <v-divider class="mb-3"></v-divider>

                <div
                  style="
                    max-height: 260px;
                    overflow-y: auto;
                    padding-right: 4px;
                  "
                  class="custom-scroll-box"
                >
                  <div
                    v-for="(grupo, gi) in comentariosPorReporte"
                    :key="gi"
                    class="mb-3"
                  >
                    <!-- Encabezado del mes si hay múltiples reportes rechazados -->
                    <div
                      v-if="comentariosPorReporte.length > 1"
                      class="caption font-weight-bold error--text mb-1 d-flex align-center"
                    >
                      <v-icon x-small color="error" class="mr-1"
                        >mdi-calendar-month</v-icon
                      >
                      {{ grupo.label }}
                    </div>

                    <div
                      v-for="(item, index) in grupo.comentarios"
                      :key="index"
                      class="pa-3 mb-2 rounded-lg bg-white elevation-1 border comment-bubble"
                    >
                      <div class="d-flex align-center mb-1">
                        <v-avatar
                          size="24"
                          color="primary lighten-4"
                          class="mr-2"
                        >
                          <v-icon x-small color="primary">mdi-account</v-icon>
                        </v-avatar>
                        <span
                          class="body-2 font-weight-bold text--primary text-truncate"
                          style="max-width: 250px"
                        >
                          {{ item.nombre_autor }}
                        </span>
                        <v-spacer></v-spacer>
                        <span
                          class="caption grey--text text--darken-1 d-flex align-center"
                        >
                          <v-icon x-small color="grey" class="mr-1"
                            >mdi-clock-outline</v-icon
                          >
                          {{ formatearFechaHora(item.created_at) }}
                        </span>
                      </div>
                      <div class="body-2 pl-8 text--secondary comment-text">
                        {{ item.comentario }}
                      </div>
                    </div>

                    <div
                      v-if="grupo.comentarios.length === 0"
                      class="caption grey--text py-2 pl-2"
                    >
                      Sin observaciones registradas para este periodo.
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions
              class="px-5 py-3 bg-white d-flex align-center justify-end"
            >
              <v-btn
                text
                color="grey darken-2"
                class="px-4 text-capitalize font-weight-medium mr-2"
                @click="cerrardialog"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="success"
                class="px-5 text-capitalize font-weight-bold rounded-lg elevation-2"
                @click="enviarpdf"
              >
                <v-icon left small>mdi-send-outline</v-icon>
                Enviar reporte
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Chart from "chart.js/auto";
import chartTrendline from "chartjs-plugin-trendline";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.register(chartTrendline);
Chart.register(ChartDataLabels);
// import axios from "axios";
import { axios2 as axios } from "@/interceptor/useApi";
import global from "@/global";
import IndicadorCosto from "../../components/indicador/tabla.vue";
import Comentarios from "@/components/administradorreporte/comentarios.vue";

export default {
  components: {
    IndicadorCosto,
    Comentarios,
  },
  data() {
    return {
      ruta_image: global.ruta_image,
      global: global,
      Item: {},
      visualizarReporte: false,
      loader: false,
      loadingConsulta: false,
      meses: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      recomendacion: {
        id: null,
        recomendacion: "",
      },
      nombreusuario: "",
      rutaImagenFirma: "",
      errorCargaFirma: false,
      dialog: false,
      dialogPDF: false,
      buttonExportar: true,
      buttoncargarpdf: true,
      pdf: "",
      loaderpdf: false,
      loaderpdfMensaje: "Generando reporte...",
      ver_iframe: false,
      pdfUrl: null,
      pdfBlobUrl: null,
      pdfPollingInterval: null,
      valid: false,
      loadingExcelScrap: false,
      role: localStorage.getItem("role"),
      dialog_enviar_pdf: false,
      filepdf: null,
      ItemSelect: [],
      comentario: "",
      comentariosPorReporte: [],
      dialogComentarios: false,
      itemComentarioSelected: {},
      reporteConsultadoActual: null,
      pageInspecciones: 1,
      itemsPerPageInspecciones: 10,
      pageRendimientosNuevos: 1,
      pageRendimientosReencauchados: 1,
      pagePerdidasScrap: 1,
      pageServicioReencauche: 1,
      pageRotacionesIrregulares: 1,
      itemsPerPage50: 50,
      dialogSeccionesExportar: false,
      seccionesSeleccionadas: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      seccionesDisponibles: [
        {
          id: 1,
          titulo: "1. Participación de reencauche",
          subsecciones: [
            "1.1 Indicador de reencauche",
            "1.2 Indicador de reencauchabilidad",
          ],
        },
        { id: 2, titulo: "2. Costo por kilómetro / hora" },
        { id: 3, titulo: "3. Pérdidas por scrap" },
        {
          id: 4,
          titulo: "4. Resumen de inspección de la operación",
          subsecciones: [
            "4.1 Equipos inspeccionados",
            "4.2 Distribución de medidas de neumáticos",
            "4.3 Distribución de marcas de neumáticos",
            "4.4 Distribución de marcas por eje",
          ],
        },
        {
          id: 5,
          titulo: "5. Estado de remanente de rodado de la flota",
          subsecciones: [
            "5.1 Niveles de remanente por unidad",
            "5.2 Niveles de remanente por medida",
          ],
        },
        { id: 6, titulo: "6. Resumen neumáticos para servicio de reencauche" },
        {
          id: 7,
          titulo: "7. Estado de presión de inflado de la flota",
          subsecciones: [
            "7.1 Inflado de neumáticos",
            "7.2 Presión de inflado de neumáticos",
          ],
        },
        { id: 8, titulo: "8. Rotaciones - Desgastes irregulares" },
        { id: 9, titulo: "9. Resumen de neumáticos en mal estado" },
        { id: 10, titulo: "10. Resumen de neumáticos en scrap" },
        { id: 11, titulo: "11. Reporte de inspecciones" },
        { id: 12, titulo: "12. Recomendaciones" },
      ],
    };
  },
  computed: {
    ...mapState("reporteconsolidado", [
      "Cliente",
      "Usuario",
      "EstadoReporte",
      "Years",
      "Months",
      "Recomendaciones",
      "EquiposInspeccionados",
      "EquiposInspeccionadoscantidad",
      "DistribucionMedidasNeumaticos",
      "PosicionRuedaSegunMarca",
      "DistribucionEjeDireccional",
      "DistribucionEjeTraccion",
      "DistribucionEjeLibre",
      "NeumaticosMalEstado",
      "NeumaticosScrap",
      "NeumaticosRetiro",
      "NivelesRemanenteUnidad",
      "ResumenRemanentesUnidad",
      "AplicacionesRemanenteUnidad",
      "NeumaticosServicioReencauche",
      "RotacionesIrregulares",
      "InfladoNeumaticos",
      "PresionNeumaticos",
      "NivelesRemanenteMedidaoficial",
      "NivelesRemanenteMedida",
      "ResumenRemanentesMedida",
      "RemanentesMedida",
      "TotalesMedida",
      "TotalDatosMedida",
      "IndiceReencauche",
      "IndiceReencauchabilidad",
      "RendimientosNeumaticosNuevos",
      "RendimientosNeumaticosReencauchados",
      "Inspecciones",
      "CostoPorKilometro",
      "PerdidasPorScrap",
      "MesesCostoPorKilometro",
      "AplicacionNivelesRemanentes",
    ]),

    ...mapState("reporteconsolidado", ["Comentarios"]),
    ...mapState("navigation", ["Mini"]),
    NivelesRemanenteUnidadPosiciones() {
      const raw =
        this.$store.state.reporteconsolidado.NivelesRemanenteUnidadPosiciones;
      if (!raw) return [];
      const lista = Array.isArray(raw)
        ? [...raw]
        : typeof raw === "object"
        ? Object.values(raw)
        : [];
      return lista.sort((a, b) => {
        const numA = Number(a);
        const numB = Number(b);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        return String(a).localeCompare(String(b), undefined, { numeric: true });
      });
    },
    listaEstadoReportes() {
      const rawData = this.EstadoReporte;
      let existingItems = [];

      if (Array.isArray(rawData)) {
        existingItems = rawData;
      } else if (
        rawData &&
        typeof rawData === "object" &&
        Object.keys(rawData).length > 0
      ) {
        existingItems = [rawData];
      }

      if (!this.Item || !this.Item.month1) {
        return existingItems;
      }

      const m1 = parseInt(this.Item.month1);
      const m2 = this.Item.month2 ? parseInt(this.Item.month2) : m1;
      const year = this.Item.year || "";

      const finalResult = [];
      const processedReportIds = new Set();

      for (let m = m1; m <= m2; m++) {
        const match = existingItems.find((item) => {
          const itemM1 = parseInt(item.consulta_mes);
          const itemM2 = item.consulta_mes_fin
            ? parseInt(item.consulta_mes_fin)
            : itemM1;
          const itemYear = item.consulta_anio;
          return itemM1 <= m && m <= itemM2 && (!year || itemYear == year);
        });

        if (match) {
          const key =
            match.id !== undefined && match.id !== null ? match.id : match;
          if (!processedReportIds.has(key)) {
            processedReportIds.add(key);
            finalResult.push(match);
          }
        } else {
          finalResult.push({
            id: null,
            consulta_mes: m,
            consulta_mes_fin: m,
            consulta_anio: year,
            estado: "NO ENVIADO",
            created_at: "-",
            comentarios: [],
          });
        }
      }

      return finalResult;
    },
    estadoReporteSeleccionado() {
      return (
        this.reporteConsultadoActual ||
        this.obtenerReporteCoincidente(this.Item)
      );
    },
    todasSeccionesSeleccionadas() {
      const todas = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      return todas.every((id) => this.seccionesSeleccionadas.includes(id));
    },
    paginatedInspecciones() {
      if (!this.Inspecciones) return [];
      const start = (this.pageInspecciones - 1) * this.itemsPerPageInspecciones;
      const end = start + this.itemsPerPageInspecciones;
      return this.Inspecciones.slice(start, end);
    },
    paginatedRendimientosNuevos() {
      if (!this.RendimientosNeumaticosNuevos) return [];
      const list = Array.isArray(this.RendimientosNeumaticosNuevos)
        ? this.RendimientosNeumaticosNuevos
        : this.RendimientosNeumaticosNuevos.kilometros || [];
      const start = (this.pageRendimientosNuevos - 1) * this.itemsPerPage50;
      const end = start + this.itemsPerPage50;
      return list.slice(start, end);
    },
    hasRendimientosNuevosKm() {
      if (!this.RendimientosNeumaticosNuevos) return false;
      if (Array.isArray(this.RendimientosNeumaticosNuevos)) {
        return this.RendimientosNeumaticosNuevos.length > 0;
      }
      return (
        Array.isArray(this.RendimientosNeumaticosNuevos.kilometros) &&
        this.RendimientosNeumaticosNuevos.kilometros.length > 0
      );
    },
    hasRendimientosNuevosHoras() {
      if (!this.RendimientosNeumaticosNuevos) return false;
      return (
        Array.isArray(this.RendimientosNeumaticosNuevos.horas) &&
        this.RendimientosNeumaticosNuevos.horas.length > 0
      );
    },
    hasRendimientosNuevos() {
      return this.hasRendimientosNuevosKm || this.hasRendimientosNuevosHoras;
    },
    paginatedRendimientosReencauchados() {
      if (!this.RendimientosNeumaticosReencauchados) return [];
      const list = Array.isArray(this.RendimientosNeumaticosReencauchados)
        ? this.RendimientosNeumaticosReencauchados
        : this.RendimientosNeumaticosReencauchados.kilometros || [];
      const start =
        (this.pageRendimientosReencauchados - 1) * this.itemsPerPage50;
      const end = start + this.itemsPerPage50;
      return list.slice(start, end);
    },
    hasRendimientosReencauchadosKm() {
      if (!this.RendimientosNeumaticosReencauchados) return false;
      if (Array.isArray(this.RendimientosNeumaticosReencauchados)) {
        return this.RendimientosNeumaticosReencauchados.length > 0;
      }
      return (
        Array.isArray(this.RendimientosNeumaticosReencauchados.kilometros) &&
        this.RendimientosNeumaticosReencauchados.kilometros.length > 0
      );
    },
    hasRendimientosReencauchadosHoras() {
      if (!this.RendimientosNeumaticosReencauchados) return false;
      return (
        Array.isArray(this.RendimientosNeumaticosReencauchados.horas) &&
        this.RendimientosNeumaticosReencauchados.horas.length > 0
      );
    },
    hasRendimientosReencauchados() {
      return (
        this.hasRendimientosReencauchadosKm ||
        this.hasRendimientosReencauchadosHoras
      );
    },
    paginatedPerdidasScrap() {
      if (!this.PerdidasPorScrap || !Array.isArray(this.PerdidasPorScrap))
        return [];
      const start = (this.pagePerdidasScrap - 1) * this.itemsPerPage50;
      const end = start + this.itemsPerPage50;
      return this.PerdidasPorScrap.slice(start, end);
    },
    paginatedServicioReencauche() {
      if (
        !this.NeumaticosServicioReencauche ||
        !Array.isArray(this.NeumaticosServicioReencauche)
      )
        return [];
      const start = (this.pageServicioReencauche - 1) * this.itemsPerPage50;
      const end = start + this.itemsPerPage50;
      return this.NeumaticosServicioReencauche.slice(start, end);
    },
    paginatedRotacionesIrregulares() {
      if (
        !this.RotacionesIrregulares ||
        !Array.isArray(this.RotacionesIrregulares)
      )
        return [];
      const start = (this.pageRotacionesIrregulares - 1) * this.itemsPerPage50;
      const end = start + this.itemsPerPage50;
      return this.RotacionesIrregulares.slice(start, end);
    },
  },
  watch: {
    Usuario: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (newVal.img_firma) {
            this.rutaImagenFirma = global.ruta_image + newVal.img_firma;
            this.errorCargaFirma = false;
          }
          if (newVal.nombres) {
            this.nombreusuario =
              newVal.nombres + " " + (newVal.apellidos || "");
          }
        }
      },
    },
  },
  methods: {
    ...mapActions("reporteconsolidado", [
      "cargarAnios",
      "cargarMeses",
      "cargarDatosReporteConsolidado",
      "saveRecomendacion",
      "deleteRecomendacion",
    ]),

    async enviar(Param) {
      try {
        const url = "comentarios/store";
        let datos = {
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
          comentario: Param,
        };
        await axios.post(url, datos);
        console.log("se agrego correctamente el comentario");
      } catch (error) {
        console.error("Error al enviar comentario:", error);
      }
    },
    ...mapActions("reporteconsolidado", ["cargarComentarios"]),
    enviarpdf: function () {
      if (this.$refs.form2.validate()) {
        const repSel =
          this.reporteConsultadoActual ||
          this.obtenerReporteCoincidente(this.ItemSelect);
        if (repSel && repSel.estado == "RECHAZADO") {
          this.enviar({ adm_rep_id: repSel.id, comentario: this.comentario });
        }
        let datos = {
          id_cliente: localStorage.getItem("idcliente"),
          x_anio: this.ItemSelect.year,
          x_mes1: this.ItemSelect.month1,
          x_mes2: this.ItemSelect.month2,
          id_usuario: localStorage.getItem("id"),
        };

        this.loader = true;
        const filtroActual = { ...this.ItemSelect };
        axios
          .post("/administradorreporte/guardarpdfservidorlocal", datos)
          .then((res) => {
            this.loader = false;
            if (res.data.success) {
              const reportesActualizados = res.data.success.datos;
              if (reportesActualizados) {
                this.$store.commit(
                  "reporteconsolidado/DatosReporte",
                  reportesActualizados,
                );
                // Esperar a que Vue recompute listaEstadoReportes antes de buscar el reporte coincidente
                this.$nextTick(() => {
                  this.reporteConsultadoActual =
                    this.obtenerReporteCoincidente(filtroActual);
                });
              }
              this.cerrardialog();
              this.$alertify.success(
                "Se envió correctamente la solicitud de aprobación.",
              );
            } else {
              this.$alertify.error(res.data.error);
            }
          })
          .catch((error) => {
            this.loader = false;
            console.error("Error al enviar el formulario:", error);
            this.$alertify.error(
              error.response?.data?.error || "Error al procesar la solicitud.",
            );
          });
      }
    },
    cantidadxmedida: function (nomtipo, marca, modelo, medida, tipo_medida) {
      for (
        let index = 0;
        index < this.EquiposInspeccionadoscantidad.length;
        index++
      ) {
        if (
          this.EquiposInspeccionadoscantidad[index].nomtipo == nomtipo &&
          this.EquiposInspeccionadoscantidad[index].marca == marca &&
          this.EquiposInspeccionadoscantidad[index].modelo == modelo &&
          this.EquiposInspeccionadoscantidad[index].medida == medida &&
          this.EquiposInspeccionadoscantidad[index].tipo_medida == tipo_medida
        ) {
          console.log(
            this.EquiposInspeccionadoscantidad[index],
            nomtipo,
            marca,
            modelo,
            medida,
            tipo_medida,
          );
          return this.EquiposInspeccionadoscantidad[index].cantidad;
        }
      }
    },
    cerrardialog: function () {
      this.filepdf = null;
      this.dialog_enviar_pdf = false;
    },

    formatearFechaHora: function (fechaStr) {
      return global.formatearFechaHora(fechaStr);
    },

    obtenerNombreMes: function (mesNum) {
      if (!mesNum) return "";
      const idx = parseInt(mesNum) - 1;
      return this.meses[idx] || "";
    },

    formatearRangoMeses: function (repItem) {
      const item = repItem || {};
      const m1 =
        item.consulta_mes !== undefined && item.consulta_mes !== null
          ? item.consulta_mes
          : this.Item
          ? this.Item.month1
          : null;
      const m2 =
        item.consulta_mes_fin !== undefined && item.consulta_mes_fin !== null
          ? item.consulta_mes_fin
          : null;
      const anio = item.consulta_anio || (this.Item ? this.Item.year : "");

      const mes1 = this.obtenerNombreMes(m1);
      const mes2 = this.obtenerNombreMes(m2);

      if (!m2 || m1 == m2) {
        return `${mes1} ${anio}`.trim();
      }
      return `${mes1} - ${mes2} ${anio}`.trim();
    },
    obtenerReporteCoincidente: function (params) {
      if (!this.listaEstadoReportes || this.listaEstadoReportes.length === 0)
        return null;
      const p = params || {};
      const m1 = p.month1 || null;
      const m2 = p.month2 || p.month1 || null;
      const year = p.year || null;

      const encontrado = this.listaEstadoReportes.find((item) => {
        const itemM1 = item.consulta_mes;
        const itemM2 = item.consulta_mes_fin || item.consulta_mes;
        const itemYear = item.consulta_anio;
        return itemM1 == m1 && itemM2 == m2 && (!year || itemYear == year);
      });

      return encontrado || this.listaEstadoReportes[0] || null;
    },

    abrirmodal(Item) {
      this.ItemSelect = { ...Item };
      this.comentariosPorReporte = [];

      // Obtener todos los reportes del rango de meses seleccionado
      const reportesRango = this.listaEstadoReportes;

      // Filtrar solo los meses RECHAZADOS que tengan id
      const rechazados = reportesRango.filter(
        (r) => r.estado === "RECHAZADO" && r.id,
      );

      if (rechazados.length === 0) {
        // No hay meses rechazados, limpiar comentarios
        this.$store.commit("reporteconsolidado/LlenarComentarios", []);
      } else {
        // Usar los comentarios que ya vienen dentro de cada reporte (de verificarestadoreporte)
        const grupos = [];
        for (const rep of rechazados) {
          const comentariosRaw =
            rep.comentarios && Array.isArray(rep.comentarios)
              ? rep.comentarios
              : [];
          const comentarios = comentariosRaw;
          grupos.push({
            label: this.formatearRangoMeses(rep),
            comentarios,
          });
        }
        this.comentariosPorReporte = grupos;
        // Unir todos para compatibilidad con el store
        const todos = grupos.flatMap((g) => g.comentarios);
        this.$store.commit("reporteconsolidado/LlenarComentarios", todos);
      }

      this.dialog_enviar_pdf = true;
    },

    onCambioFiltros: function () {
      this.buttonExportar = true;
      this.buttoncargarpdf = true;
      this.visualizarReporte = false;
    },

    onMeses: function (anio) {
      this.Item.month1 = null;
      this.Item.month2 = null;
      this.buttonExportar = true;
      this.buttoncargarpdf = true;
      this.visualizarReporte = false;
      this.$refs.form.resetValidation();
      this.cargarMeses(anio);
    },

    abrirComentariosVisual: function (repItem) {
      const itemObj =
        repItem ||
        (Array.isArray(this.EstadoReporte)
          ? this.EstadoReporte[0]
          : this.EstadoReporte);
      if (itemObj) {
        let comentarios = [];
        if (itemObj.comentarios && Array.isArray(itemObj.comentarios)) {
          comentarios = itemObj.comentarios;
        }
        this.$store.commit("reporteconsolidado/LlenarComentarios", comentarios);
        this.itemComentarioSelected = {
          adm_rep_id: itemObj.id,
          comentario: null,
        };
        this.dialogComentarios = true;
      } else {
        this.$alertify.error("No hay información de observaciones disponible.");
      }
    },

    consultarDatos: async function () {
      this.visualizarReporte = false;
      this.reporteConsultadoActual = null;
      this.pageInspecciones = 1;
      this.pageRendimientosNuevos = 1;
      this.pageRendimientosReencauchados = 1;
      this.pagePerdidasScrap = 1;
      this.pageServicioReencauche = 1;
      this.pageRotacionesIrregulares = 1;
      await this.$nextTick();

      if (!this.Item.month2) {
        this.Item.month2 = this.Item.month1;
      }

      if (parseInt(this.Item.month1) <= parseInt(this.Item.month2)) {
        this.loader = true;
        this.loadingConsulta = true;
        try {
          const response = await this.cargarDatosReporteConsolidado(this.Item);
          const isSuccess =
            response &&
            (response.status === 200 ||
              response.status === 201 ||
              (response.data && !response.data.error));

          if (isSuccess) {
            this.visualizarReporte = true;
            this.reporteConsultadoActual = this.obtenerReporteCoincidente(
              this.Item,
            );
            await this.$nextTick();
            this.graficoDistribucionMedidas();
            this.graficoPosicionRuedaSegunMarca();
            this.graficoDistribucionMarcasEjeDireccional();
            this.graficoDistribucionMarcasEjeTraccion();
            this.graficoDistribucionMarcasEjeLibre();
            this.graficoInfladoNeumaticos();
            this.graficoPresionNeumaticos();
            this.graficoIndiceReencauche();
            this.graficoIndiceReencauchabilidad();
            this.buttonExportar = false;
          } else {
            this.visualizarReporte = false;
          }
        } catch (error) {
          console.error("Error al consultar datos:", error);
          this.visualizarReporte = false;
        } finally {
          this.loader = false;
          this.loadingConsulta = false;
        }
      } else {
        this.loader = false;
        this.loadingConsulta = false;
        this.$alertify.error(
          "Por favor, ingresar un mes igual o mayor al primer mes seleccionado",
        );
      }
    },

    graficoPie: function (id_grafico, labels, title, data) {
      var popCanvas = document.getElementById(id_grafico);
      if (!popCanvas) return;
      new Chart(popCanvas, {
        plugins: [ChartDataLabels],
        type: "pie",
        data: {
          labels: labels,
          datasets: [
            {
              label: "My First Dataset",
              data: data,
              backgroundColor: [
                "rgb(255, 99, 132)",
                "rgb(27, 205, 249)",
                "rgb(255, 205, 86)",
                "rgb(218, 247, 166)",
                "rgb(27, 216, 176)",
                "rgb(253, 152, 37)",
                "rgb(254, 243, 80 )",
                "rgb(179, 241, 238)",
                "rgb(125, 254, 80)",
                "rgb(54, 162, 235)",
              ],
              hoverOffset: 4,
            },
          ],
        },
        options: {
          //indexAxis: 'y',
          plugins: {
            legend: {
              display: true,
              position: "right",
              labels: {
                color: "black",
                font: {
                  size: 11,
                },
              },
            },
            datalabels: {
              /* anchor puede ser "start", "center" o "end" */
              anchor: "center",
              /* Podemos modificar el texto a mostrar */
              //formatter: (dato) => dato + "%",
              formatter: (dato) => dato,
              /* Color del texto */
              color: "black",
              /* Formato de la fuente */
              font: {
                family: '"Times New Roman", Times, serif',
                size: "10",
                weight: "bold",
              },
              /* Formato de la caja contenedora */
              padding: "4",
              borderWidth: 2,
              //borderColor: "darkblue",
              borderRadius: 8,
              backgroundColor: "white",
            },
          },
          tooltips: {
            yAlign: "bottom",
            xAlign: "center",
            xPadding: 25,
            yPadding: 15,
            xPadding: 45,
            _bodyAlign: "center",
            _footerAlign: "center",
            backgroundColor: "#ccc",
            titleFontSize: 16,
            titleFontColor: "#0066ff",
            bodyFontColor: "#000",
            bodyFontSize: 14,
            displayColors: false,
          },
        },
      });
    },

    graficoBar: function (id_grafico, labels, title, data) {
      var popCanvas = document.getElementById(id_grafico);
      if (!popCanvas) return;
      new Chart(popCanvas, {
        plugins: [ChartDataLabels],
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Neumáticos",
              data: data,
              backgroundColor: ["rgb(27, 205, 249)"],
              hoverOffset: 4,
            },
          ],
        },
        options: {
          indexAxis: "y",
          scales: {
            x: {
              beginAtZero: true, // Asegura que el eje X (eje horizontal en un gráfico de barras horizontales) comience desde 0
              suggestedMin: 0, // Asegura que el gráfico comience desde 0 en el eje X
            },
          },
          plugins: {
            legend: {
              display: false,
              position: "right",
              labels: {
                color: "black",
                font: {
                  size: 11,
                },
              },
            },
            datalabels: {
              /* anchor puede ser "start", "center" o "end" */
              anchor: "center",
              /* Podemos modificar el texto a mostrar */
              //formatter: (dato) => dato + "%",
              formatter: (dato) => dato,
              /* Color del texto */
              color: "black",
              /* Formato de la fuente */
              font: {
                family: '"Times New Roman", Times, serif',
                size: "10",
                weight: "bold",
              },
              /* Formato de la caja contenedora */
              //padding: "4",
              //borderWidth: 2,
              //borderColor: "darkblue",
              //borderRadius: 8,
              //backgroundColor: "white"
            },
          },
          tooltips: {
            yAlign: "bottom",
            xAlign: "center",
            xPadding: 25,
            yPadding: 15,
            xPadding: 45,
            _bodyAlign: "center",
            _footerAlign: "center",
            backgroundColor: "#ccc",
            titleFontSize: 16,
            titleFontColor: "#0066ff",
            bodyFontColor: "#000",
            bodyFontSize: 14,
            displayColors: false,
          },
        },
      });
    },

    graficoDistribucionMedidas: function () {
      let etiquetas = [];
      let data = [];
      this.DistribucionMedidasNeumaticos.forEach((element) => {
        let descripcion =
          element.descripcion + " (" + element.porcentaje + "%) ";
        etiquetas.push(descripcion);
        data.push(element.count_medida);
      });
      this.graficoPie("pieMedidas", etiquetas, "", data);
    },

    graficoPosicionRuedaSegunMarca: function () {
      let etiquetas = [];
      let data = [];
      this.PosicionRuedaSegunMarca.forEach((element) => {
        let descripcion =
          element.desc_marca + " (" + element.porcentaje + "%) ";
        etiquetas.push(descripcion);
        data.push(element.cantidad_marca);
      });
      this.graficoPie("pieMarcas", etiquetas, "", data);
    },

    graficoDistribucionMarcasEjeDireccional: function () {
      let etiquetas = [];
      let data = [];
      this.DistribucionEjeDireccional.forEach((element) => {
        //let descripcion =
        //element.desc_marca + " (" + element.porcentaje + "%) ";
        etiquetas.push(element.desc_marca);
        data.push(element.cantidad_marca);
      });
      if (this.DistribucionEjeDireccional.length > 0)
        this.graficoBar("barDireccional", etiquetas, "", data);
    },

    graficoDistribucionMarcasEjeTraccion: function () {
      let etiquetas = [];
      let data = [];
      this.DistribucionEjeTraccion.forEach((element) => {
        //let descripcion =
        //element.desc_marca + " (" + element.porcentaje + "%) ";
        etiquetas.push(element.desc_marca);
        data.push(element.cantidad_marca);
      });
      if (this.DistribucionEjeTraccion.length > 0)
        this.graficoBar("barTraccion", etiquetas, "", data);
    },

    graficoDistribucionMarcasEjeLibre: function () {
      let etiquetas = [];
      let data = [];
      this.DistribucionEjeLibre.forEach((element) => {
        //let descripcion =
        //element.desc_marca + " (" + element.porcentaje + "%) ";
        etiquetas.push(element.desc_marca);
        data.push(element.cantidad_marca);
      });
      if (this.DistribucionEjeLibre.length > 0)
        this.graficoBar("barLibre", etiquetas, "", data);
    },

    tdPintar: function (nsk_minimo, rem_reencauche, rem_proximo) {
      let rem_proximo_aru = parseFloat(rem_proximo) ?? 0;
      let rem_reencauche_aru = parseFloat(rem_reencauche) ?? 0;
      let pintar = "";
      if (
        nsk_minimo !== null &&
        nsk_minimo !== undefined &&
        nsk_minimo !== "" &&
        nsk_minimo !== "-" &&
        !isNaN(parseFloat(nsk_minimo))
      ) {
        let nsk = parseFloat(nsk_minimo);
        if (nsk <= rem_proximo_aru && nsk > rem_reencauche_aru) {
          pintar = "border texto-cen bg-celda-azul pa-1";
        } else if (nsk <= rem_reencauche_aru) {
          pintar = "border texto-cen bg-celda-amarilla pa-1";
        } else {
          pintar = "border texto-cen pa-1";
        }
      } else {
        pintar = "border texto-cen pa-1";
      }
      return pintar;
    },

    tdPintarRemanente: function (pos, rem_reencauche, rem_proximo) {
      let pintar = this.tdPintar(pos, rem_reencauche, rem_proximo);
      return pintar;
    },

    pintarCostoPorKilometro: function (item, valor) {
      let pintar = "border texto-cen";

      if (
        valor !== null &&
        valor !== undefined &&
        valor !== "" &&
        valor !== "-" &&
        !isNaN(parseFloat(valor))
      ) {
        let val = parseFloat(valor);
        let rango_inf = parseFloat(item.rango_c_inferior);
        let rango_sup = parseFloat(item.rango_c_superior);
        let crit_sup = parseFloat(item.criterio_superior);
        let crit_inf = parseFloat(item.criterio_inferior);

        if (val >= rango_inf && val <= rango_sup)
          pintar = "border texto-cen bg-celda-amarilla";
        if (val < crit_sup) pintar = "border texto-cen bg-celda-verde";
        if (val > crit_inf) pintar = "border texto-cen bg-celda-roja";
      }
      return pintar;
    },

    tdValorPosicion: function (index, item2) {
      return this.NivelesRemanenteUnidad[index]["nsk_minimo_" + item2];
    },

    tdValorCosto: function (index, item2) {
      return this.CostoPorKilometro[index]["indicador_mes_" + item2];
    },

    tdValorRemanente: function (index1, index, item2) {
      return this.NivelesRemanenteMedida[index1][index][
        "totalneumaticos_nsk_minimo_" + item2
      ];
    },

    graficoInfladoNeumaticos: function () {
      let etiquetas = [];
      let data = [];
      this.InfladoNeumaticos.forEach((element) => {
        let descripcion =
          element.descripcion + " (" + element.porcentaje + "%) ";
        etiquetas.push(descripcion);
        data.push(element.cantidad);
      });
      this.graficoPie("pieInflado", etiquetas, "", data);
    },

    graficoPresionNeumaticos: function () {
      let etiquetas = [];
      let data = [];
      this.PresionNeumaticos.forEach((element) => {
        let descripcion =
          element.descripcion + " (" + element.porcentaje + "%) ";
        etiquetas.push(descripcion);
        data.push(element.cantidad);
      });
      this.graficoPie("piePresion", etiquetas, "", data);
    },

    nameAplicacionRemanente: function () {
      const value =
        this.AplicacionNivelesRemanentes.length > 0
          ? this.AplicacionNivelesRemanentes[0]["nombre_aplicacion"]
          : 0;

      if (value === 0) {
        return 0;
      }

      return value;
    },

    colspanRemParaReencauche: function (index1, rem_reencauche) {
      const rmParaReenc =
        this.AplicacionNivelesRemanentes.length > 0
          ? parseInt(rem_reencauche)
          : 0;

      if (rmParaReenc === 0) {
        return 0;
      }

      const value = this.RemanentesMedida[index1].reduce((count, element) => {
        return count + (element <= rmParaReenc ? 1 : 0);
      }, 0);

      // console.log('value RParaR> ', value);
      return value;
    },

    colspanRemProxReencauche: function (index1, rem_reencauche, rem_proximo) {
      const rmParaReenc =
        this.AplicacionNivelesRemanentes.length > 0
          ? parseInt(rem_reencauche)
          : 0;
      const rmProxReenc =
        this.AplicacionNivelesRemanentes.length > 0 ? parseInt(rem_proximo) : 0;
      if (rmParaReenc === 0 || rmProxReenc === 0) {
        return 0;
      }

      const value = this.RemanentesMedida[index1].reduce((count, element) => {
        return (
          count + (rmParaReenc < element && element <= rmProxReenc ? 1 : 0)
        );
      }, 0);

      // console.log('value RProxR> ', value);
      return value;
    },

    calcularPorcentajes: function (cantidad, total) {
      let porcentaje = 0;
      total = total == 0 || total == undefined || total == null ? 1 : total;
      cantidad =
        cantidad == 0 || cantidad == undefined || cantidad == null
          ? 0
          : cantidad;
      porcentaje = (cantidad / total) * 100;

      return porcentaje.toFixed(2) + "%";
    },

    mostrarPorcentaje: function (array) {
      if (array.length > 0) {
        return "100%";
      } else {
        return "0%";
      }
    },

    graficoIndiceReencauche: function () {
      let etiquetas = [];
      let data = [];

      this.IndiceReencauche.forEach((element) => {
        let descripcion =
          element.description + " (" + element.porcentaje + "%) ";
        etiquetas.push(descripcion);
        data.push(element.cantidad);
      });
      this.graficoPie("pieReencauche", etiquetas, "", data);
    },

    graficoIndiceReencauchabilidad: function () {
      let array = [];
      let data = [];
      let etiquetas = [];
      array.push({
        descripcion: "Reencauchabilidad",
        cantidad: this.IndiceReencauchabilidad,
      });

      array.forEach((element) => {
        etiquetas.push(element.descripcion);
        data.push(element.cantidad);
      });

      var popCanvas = document.getElementById("barReencauchabilidad");
      if (!popCanvas) return;
      new Chart(popCanvas, {
        type: "bar",
        data: {
          labels: etiquetas,
          datasets: [
            {
              label: "Neumáticos",
              data: data,
              backgroundColor: ["rgb(27, 205, 249)"],
              hoverOffset: 4,
            },
          ],
        },
        options: {
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            y: {
              type: "linear",
              beginAtZero: true,
              suggestedMin: 0,
              suggestedMax: 2,
            },
          },
          tooltips: {
            yAlign: "bottom",
            xAlign: "center",
            xPadding: 25,
            yPadding: 15,
            xPadding: 45,
            _bodyAlign: "center",
            _footerAlign: "center",
            backgroundColor: "#ccc",
            titleFontSize: 16,
            titleFontColor: "#0066ff",
            bodyFontColor: "#000",
            bodyFontSize: 14,
            displayColors: false,
          },
        },
      });
    },
    tamanioTabla: function () {
      if (this.Mini == true) {
        return "max-width: 950px";
      } else {
        return "max-width: 860px";
      }
    },
    guardarRecomendacion: async function (item) {
      if (item) {
        this.Item.id_recomendacion = item.id;
        this.Item.descripcion_recomendacion = item.recomendaciones;
      } else {
        this.Item.id_recomendacion = null;
        this.Item.descripcion_recomendacion =
          this.recomendacion && this.recomendacion.descripcion
            ? this.recomendacion.descripcion
            : "";
        this.recomendacion = { id: null, descripcion: "" };
      }
      if (
        this.Item.descripcion_recomendacion != undefined &&
        this.Item.descripcion_recomendacion != null &&
        this.Item.descripcion_recomendacion != ""
      ) {
        let rpta = await this.saveRecomendacion(this.Item);
        if (rpta == true) {
          this.$alertify.success("Agregado con éxito ");
        } else {
          this.$alertify.success("Editado con éxito");
        }
        this.recomendacion = { id: null, descripcion: "" };
      } else {
        this.$alertify.error("El campo Recomendacion no puede ser vacio");
      }
    },
    eliminarRecomendacion: function (index, item) {
      this.dialog = true;
      this.recomendacion = {
        index: index,
        id: item ? item.id : null,
        descripcion: item ? item.recomendaciones : "",
      };
    },
    confirmar: function () {
      if (this.recomendacion && this.recomendacion.id != null) {
        let data = {
          id: this.recomendacion.id,
          index: this.recomendacion.index,
        };
        this.deleteRecomendacion(data);
      }
      this.dialog = false;
      this.recomendacion = { id: null, descripcion: "" };
    },
    generarPDF: async function (item) {
      // Limpiar estado previo
      this.ver_iframe = false;
      this.pdfUrl = null;
      this.loaderpdf = true;
      this.loaderpdfMensaje = "Preparando reporte...";
      this.dialogPDF = false;

      // Limpiar polling anterior si existía
      if (this.pdfPollingInterval) {
        clearInterval(this.pdfPollingInterval);
        this.pdfPollingInterval = null;
      }

      const data = {
        id_cliente: localStorage.getItem("idcliente"),
        id_usuario: localStorage.getItem("id"),
        year: item.year,
        month1: item.month1,
        month2: item.month2,
        secciones_reporte: this.seccionesSeleccionadas,
      };

      try {
        // PASO 1: Guardar parámetros y obtener el UUID
        const savePdfResponse = await axios.post("reporte/savePdf", data);
        const uuid = savePdfResponse.data.datos.uuid;
        this.pdf = savePdfResponse.data.datos;
        this.buttoncargarpdf = false;

        // PASO 2: Iniciar el job en background
        this.loaderpdfMensaje = "Generando reporte PDF en segundo plano...";
        await axios.get("reporte/pdf/" + uuid);

        // PASO 3: Polling cada 5 segundos para saber cuándo está listo
        this.pdfPollingInterval = setInterval(async () => {
          try {
            const statusResponse = await axios.get(
              "reporte/pdf/status/" + uuid,
            );
            const statusData = statusResponse.data;

            if (statusData.status === "done" && statusData.url) {
              // PDF listo → detener polling y descargar blob atómico
              clearInterval(this.pdfPollingInterval);
              this.pdfPollingInterval = null;
              this.loaderpdfMensaje = "Cargando documento en el visor...";

              try {
                const downloadUrl = "reporte/pdf/descargar/" + uuid;
                const pdfResponse = await axios.get(downloadUrl, {
                  responseType: "blob",
                });

                if (this.pdfBlobUrl) {
                  URL.revokeObjectURL(this.pdfBlobUrl);
                }

                const blob = new Blob([pdfResponse.data], {
                  type: "application/pdf",
                });
                this.pdfBlobUrl = URL.createObjectURL(blob);
                this.pdfUrl = this.pdfBlobUrl;
                this.loaderpdf = false;
                this.ver_iframe = true;
                this.dialogPDF = true;
              } catch (blobError) {
                console.error("Error al descargar blob del PDF:", blobError);
                this.loaderpdf = false;
                this.dialogPDF = false;
                this.$alertify.error(
                  "No se pudo cargar el archivo PDF generado.",
                );
              }
            } else if (statusData.status === "failed") {
              // Error en la generación
              clearInterval(this.pdfPollingInterval);
              this.pdfPollingInterval = null;
              this.loaderpdf = false;
              this.loaderpdfMensaje = "Error al generar el reporte.";
              console.error("Error generando PDF:", statusData.error);
              this.$alertify.error(
                statusData.error ||
                  "Ocurrió un error al generar el reporte PDF. Intente nuevamente.",
              );
              this.dialogPDF = false;
            } else {
              // Aún procesando
              this.loaderpdfMensaje = "Generando reporte... por favor espere.";
            }
          } catch (pollError) {
            console.error("Error en polling:", pollError);
            clearInterval(this.pdfPollingInterval);
            this.pdfPollingInterval = null;
            this.loaderpdf = false;
            this.dialogPDF = false;
            this.$alertify.error(
              "Error de conexión al consultar el estado del reporte.",
            );
          }
        }, 5000);
      } catch (error) {
        console.error("Error al iniciar generación de PDF:", error);
        this.loaderpdf = false;
        this.dialogPDF = false;
        this.$alertify.error(
          "No se pudo iniciar la generación del reporte. Intente nuevamente.",
        );
      }
    },
    cerrarVisor: function () {
      // Limpiar el polling si existe (puede que aún no haya iniciado si el usuario canceló muy rápido)
      if (this.pdfPollingInterval) {
        clearInterval(this.pdfPollingInterval);
        this.pdfPollingInterval = null;
      }

      // Notificar al backend la cancelación si hay un job en curso,
      // independientemente de si el polling ya había iniciado o no.
      // Bug fix: antes esto estaba dentro del if(pdfPollingInterval), lo que hacía
      // que si el usuario cancelaba antes de que el intervalo se creara, el API
      // de cancelar nunca se llamaba y el job seguía ejecutándose en el backend.
      if (this.loaderpdf && this.pdf && this.pdf.uuid) {
        axios.post("reporte/pdf/cancelar/" + this.pdf.uuid).catch((err) => {
          console.error("Error al cancelar reporte en el backend:", err);
        });
      }

      if (this.pdfBlobUrl) {
        URL.revokeObjectURL(this.pdfBlobUrl);
        this.pdfBlobUrl = null;
      }

      this.dialogPDF = false;
      this.ver_iframe = false;
      this.pdfUrl = null;
      this.loaderpdf = false;
      this.loaderpdfMensaje = "Generando reporte...";
    },

    _json_to_query_string: function (json) {
      json = Object.keys(json).map((item) => {
        return item + "=" + json[item] || "";
      });
      return json.join("&");
    },

    exportarAExcelScrapxMotivo: async function () {
      try {
        this.loadingExcelScrap = true;
        const url =
          global.ruta_api +
          "excel/reportescrapmotivo?" +
          global._json_to_query_string({
            id_cliente: localStorage.getItem("idcliente"),
            year: this.Item.year,
            month1: this.Item.month1,
            month2: this.Item.month2,
          });

        await axios({
          url: url,
          method: "GET",
          responseType: "blob",
        })
          .then(async (response) => {
            this.loadingExcelScrap = false;
            var nombre_archivo = response.headers["nombre-archivo"];
            if (response.data.type == "text/html") {
              // no es excel, probablemente es json con un mensaje de error
              const res = JSON.parse(await response.data.text());
              if (!res.exito) {
                alert(res.mensaje || "Sucedió un error, intentelo nuevamente");
              }
            } else {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", nombre_archivo);
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("error!", error);
          });
      } catch (error) {
        console.log(error);
      }
    },

    calcularCantidadNeumaticosScrap() {
      let cantidad = 0;
      this.NeumaticosScrap.forEach((element) => {
        cantidad += element.cantidad;
      });
      return cantidad;
    },

    calcularPorcentajeNeumaticosScrap() {
      let porcentaje = 0;
      this.NeumaticosScrap.forEach((element) => {
        porcentaje += element.porcentaje;
      });
      return porcentaje.fixed();
    },

    toggleSeleccionarTodas() {
      const todas = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      if (this.todasSeccionesSeleccionadas) {
        this.seccionesSeleccionadas = [];
      } else {
        this.seccionesSeleccionadas = [...todas];
      }
    },

    marcarTodasSecciones() {
      const todas = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      this.seccionesSeleccionadas = [...todas];
    },

    toggleSeccion(id) {
      const index = this.seccionesSeleccionadas.indexOf(id);
      if (index > -1) {
        this.seccionesSeleccionadas = this.seccionesSeleccionadas.filter(
          (item) => item !== id,
        );
      } else {
        this.seccionesSeleccionadas = [...this.seccionesSeleccionadas, id];
      }
    },

    desmarcarTodasSecciones() {
      this.seccionesSeleccionadas = [];
    },

    abrirModalSeccionesExportar() {
      this.marcarTodasSecciones();
      this.dialogSeccionesExportar = true;
    },

    confirmarExportarPDF() {
      if (
        !this.seccionesSeleccionadas ||
        this.seccionesSeleccionadas.length === 0
      ) {
        this.$alertify.error(
          "Debe seleccionar al menos una sección para exportar.",
        );
        return;
      }
      this.dialogSeccionesExportar = false;
      this.generarPDF(this.Item);
    },
  },
  async mounted() {
    if (this.Usuario) {
      if (this.Usuario.img_firma) {
        this.rutaImagenFirma = global.ruta_image + this.Usuario.img_firma;
        this.errorCargaFirma = false;
      }
      if (this.Usuario.nombres) {
        this.nombreusuario =
          this.Usuario.nombres + " " + (this.Usuario.apellidos || "");
      }
    }
    await this.cargarAnios();
    if (this.Usuario) {
      if (this.Usuario.img_firma) {
        this.rutaImagenFirma = global.ruta_image + this.Usuario.img_firma;
      }
      if (this.Usuario.nombres) {
        this.nombreusuario =
          this.Usuario.nombres + " " + (this.Usuario.apellidos || "");
      }
    }
  },
  beforeDestroy() {
    if (this.pdfPollingInterval) {
      clearInterval(this.pdfPollingInterval);
      this.pdfPollingInterval = null;
    }
    if (this.pdfBlobUrl) {
      URL.revokeObjectURL(this.pdfBlobUrl);
      this.pdfBlobUrl = null;
    }
  },
};
</script>

<style scoped>
/* Card y Header Modernos */
.modern-report-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden;
  background: #ffffff !important;
}

.report-header-banner {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.header-main-info {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-help-btn {
  flex: 0 0 auto;
  flex-shrink: 0;
  white-space: nowrap;
}

.header-icon-box {
  width: 42px;
  height: 42px;
  min-width: 42px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.header-company-title {
  font-size: 1.05rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-report-subtitle {
  color: #94a3b8;
  font-size: 0.78rem;
  font-weight: 500;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Toolbar responsive */
.v-toolbar.px-3 .text-subtitle-1,
.v-toolbar.px-4 .text-subtitle-1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.v-toolbar ::v-deep .v-toolbar__content {
  min-width: 0;
}

.v-toolbar ::v-deep .v-toolbar__content > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1 1 0;
}

/* Chips dentro de toolbars: tamaño controlado, texto centrado */
.v-toolbar ::v-deep .v-chip {
  flex-shrink: 0 !important;
  max-width: 140px !important;
  min-width: 0 !important;
  overflow: hidden !important;
  justify-content: center !important;
}

.v-toolbar ::v-deep .v-chip .v-chip__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 100% !important;
}

.info-hint-block {
  flex-wrap: nowrap;
  line-height: 1.5;
}

/* Contenedor de botones de acción */
.report-action-buttons-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}

.btn-action-responsive {
  flex-shrink: 0;
}

.summary-header-chip {
  background: rgba(255, 255, 255, 0.14) !important;
  color: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.22) !important;
  font-weight: 500;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
  transform: scale(1.06);
}

/* Card interna de Filtros */
.dashboard-chart-card {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.25s ease, border-color 0.2s ease;
}

.dashboard-chart-card:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05) !important;
}

.chart-subtitle-bar {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.815rem;
  line-height: 1.35;
  min-height: 42px;
}

/* Campos de formulario */
.field-custom ::v-deep .v-input__slot {
  background: #f8fafc !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.field-custom ::v-deep .v-input__slot:hover {
  background: #ffffff !important;
}

.field-custom ::v-deep .v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}

/* Bloque Inspector y Contenedor de Firma */
.inspector-card-wrapper {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.firma-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.firma-badge {
  font-size: 10.5px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}

.firma-box {
  width: 100%;
  height: 68px;
  border: 1.5px dashed #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transition: all 0.2s ease;
  padding: 4px;
}

.firma-box:hover {
  border-color: #94a3b8;
  background: #ffffff;
}

.firma-img {
  max-width: 150px;
  max-height: 58px;
}

.firma-fallback {
  padding: 4px;
  text-align: center;
}

/* Acciones y Botones Modernos */
.report-actions-container {
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 12px 20px !important;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.btn-action-custom {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
  height: 40px !important;
  min-width: 155px !important;
  padding: 0 18px !important;
  font-size: 0.875rem !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Estados habilitados con colores y gradientes normales */
.btn-consultar:not(.v-btn--disabled):not(:disabled) {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.3) !important;
}

.btn-consultar:not(.v-btn--disabled):not(:disabled):hover {
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.45) !important;
  transform: translateY(-1px);
}

.btn-exportar:not(.v-btn--disabled):not(:disabled) {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.3) !important;
}

.btn-exportar:not(.v-btn--disabled):not(:disabled):hover {
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.45) !important;
  transform: translateY(-1px);
}

.btn-cargar-reporte:not(.v-btn--disabled):not(:disabled) {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.3) !important;
}

.btn-cargar-reporte:not(.v-btn--disabled):not(:disabled):hover {
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.45) !important;
  transform: translateY(-1px);
}

.btn-action-custom:not(.v-btn--disabled):not(:disabled) .v-btn__content,
.btn-action-custom:not(.v-btn--disabled):not(:disabled) .v-icon {
  color: #ffffff !important;
}

/* Estado deshabilitado: gris uniforme para los tres botones */
.btn-action-custom.v-btn--disabled,
.btn-action-custom:disabled {
  background: #e2e8f0 !important;
  background-image: none !important;
  border: 1px solid #cbd5e1 !important;
  box-shadow: none !important;
  cursor: not-allowed !important;
  opacity: 1 !important;
}

.btn-action-custom.v-btn--disabled .v-btn__content,
.btn-action-custom.v-btn--disabled .v-icon,
.btn-action-custom:disabled .v-btn__content,
.btn-action-custom:disabled .v-icon {
  color: #94a3b8 !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .report-header-banner {
    padding: 12px 14px;
    gap: 8px;
  }

  .header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
  }

  .header-company-title {
    font-size: 0.93rem;
  }

  .header-report-subtitle {
    font-size: 0.72rem;
  }

  /* Botones de acción: columna completa en móvil */
  .report-action-buttons-row {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
  }

  .btn-action-responsive {
    width: 100% !important;
    display: block !important;
  }

  .btn-action-custom {
    width: 100% !important;
    min-width: unset !important;
    max-width: 100% !important;
  }

  .btn-action-responsive > .btn-action-custom {
    width: 100% !important;
  }

  /* Toolbars: texto más pequeño y truncado en móvil */
  .v-toolbar.px-3 .text-subtitle-1,
  .v-toolbar.px-4 .text-subtitle-1 {
    font-size: 0.82rem !important;
    line-height: 1.2 !important;
  }

  .v-toolbar.px-3 ::v-deep .v-toolbar__content,
  .v-toolbar.px-4 ::v-deep .v-toolbar__content {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  /* Header banner: texto aún más compacto */
  .header-company-title {
    font-size: 0.85rem !important;
  }

  .header-report-subtitle {
    font-size: 0.68rem !important;
  }
}

/* RESPONSIVE: Small tablet (601px - 959px) */
@media (min-width: 601px) and (max-width: 959px) {
  .report-action-buttons-row {
    justify-content: flex-start;
  }

  .btn-action-custom {
    min-width: 140px !important;
  }
}

.seccion-card-grupo {
  border-left: 4px solid #1976d2 !important;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.seccion-card-grupo:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08) !important;
}

.subseccion-item {
  transition: background-color 0.15s ease;
}

.subseccion-item:hover {
  background-color: #f1f5f9;
}

.subseccion-selected {
  background-color: #eff6ff;
}

.seccion-card-simple {
  border-left: 4px solid #94a3b8 !important;
  transition: all 0.2s ease;
}

.seccion-card-simple:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08) !important;
}

.seccion-simple-selected {
  border-left-color: #1976d2 !important;
  background-color: #fafafa;
}

table {
  border-collapse: collapse;
}

/*
td {
    vertical-align: top;
}
*/

.border {
  border-style: solid;
  border-width: 1px;
}

.border-bottom {
  border-bottom: solid;
  border-width: 1px;
}

.border-top {
  border-top: solid;
  border-width: 1px;
}

.border-left {
  border-left: solid;
  border-width: 1px;
}

.border-right {
  border-right: solid;
  border-width: 1px;
}

.no-border {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
}

.no-border-left {
  border-left: none;
}

.no-border-bottom {
  border-bottom: none;
}

.no-border-right {
  border-right: none;
}

.texto-cen {
  text-align: center;
}

.texto-izq {
  text-align: left;
}

.texto-just {
  text-align: justify;
}

.inline {
  display: inline-block;
}

.texto-arriba {
  vertical-align: text-top;
  vertical-align: top;
}

.letra-6 {
  font-size: 6pt;
}

.letra-7 {
  font-size: 7pt;
}

.letra-8 {
  font-size: 8pt;
}

.letra-9 {
  font-size: 9pt;
}

.letra-10 {
  font-size: 10pt;
}

.letra-11 {
  font-size: 11pt;
}

.letra-12 {
  font-size: 12pt;
}

.letra-14 {
  font-size: 14pt;
}

.letra-15 {
  font-size: 15pt;
}

.letra-18 {
  font-size: 18pt;
}

.letra-25 {
  font-size: 25pt;
}

.letra-30 {
  font-size: 30pt;
}

.margin-top-20 {
  margin-top: 20px;
}

.bg-celda-azul {
  background: #91e3da;
}

.bg-celda-amarilla {
  background: #faec5c;
  /*color:#EDDF04;*/
}

.bg-celda-verde {
  background: #a8fa6f;
}

.bg-celda-roja {
  background: #f55f50;
}

#table {
  display: block;
  /* important */
  width: 100px;
  overflow-x: scroll;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

/* Dashboard Chart Presentation & UI/UX Styles */
.dashboard-chart-card {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.25s ease, border-color 0.2s ease;
}

.dashboard-chart-card:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08),
    0 8px 10px -6px rgba(0, 0, 0, 0.04) !important;
}

.chart-subtitle-bar {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.815rem;
  line-height: 1.35;
  min-height: 38px;
}

.chart-canvas-container {
  background-color: #ffffff;
  min-height: 320px;
  position: relative;
  width: 100%;
}

.chart-empty-state {
  min-height: 280px;
  background-color: #f8fafc;
}

/* Seguimiento del Reporte Consolidado Styles */
.tracking-card {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff;
}

.tracking-table-wrapper {
  overflow-x: auto;
  width: 100%;
}

.modern-tracking-table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  font-family: inherit;
}

.modern-tracking-table thead th {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  color: #334155;
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 12px 14px;
  border-bottom: 2px solid #cbd5e1;
  border-top: none;
  white-space: nowrap;
}

.modern-tracking-table tbody tr {
  transition: background-color 0.2s ease, transform 0.15s ease;
  border-bottom: 1px solid #e2e8f0;
}

.modern-tracking-table tbody tr:last-child {
  border-bottom: none;
}

.modern-tracking-table tbody tr:hover {
  background-color: #f8fafc;
}

.modern-tracking-table tbody td {
  padding: 10px 14px;
  border-bottom: 1px solid #edf2f7;
  color: #1e293b;
  vertical-align: middle;
}

.tracking-period-badge {
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #1e293b;
  font-weight: 600;
  letter-spacing: 0.2px;
}

.action-comment-btn {
  transition: transform 0.18s ease, box-shadow 0.18s ease !important;
}

.action-comment-btn:hover {
  transform: scale(1.08);
  box-shadow: 0 4px 10px rgba(217, 119, 6, 0.4) !important;
}

/* Modal Enviar Reporte Consolidado Styles */
.enviar-reporte-card {
  border: 1px solid #e2e8f0;
}

.send-report-alert {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #1e3a8a;
}

.send-alert-icon-wrap {
  background: #dbeafe;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.summary-detail-box {
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.border-top-light {
  border-top: 1px dashed #e2e8f0;
}

.comment-bubble {
  border: 1px solid #e2e8f0 !important;
  transition: all 0.2s ease;
}

.comment-bubble:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
}

.comment-text {
  font-size: 0.85rem;
  line-height: 1.4;
}

.custom-scroll-box::-webkit-scrollbar {
  width: 6px;
}

.custom-scroll-box::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.custom-scroll-box::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.custom-scroll-box::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Tabla Moderna de Equipos Inspeccionados */
.equipos-table-wrapper {
  overflow-x: auto;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.modern-equipos-table {
  width: 100%;
  min-width: 780px;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.815rem;
  color: #1e293b;
}

/* Encabezados: Color oscuro uniforme para todo el head y texto claro (sin gradientes) */
.modern-equipos-table thead th {
  background: #1e293b !important;
  color: #ffffff !important;
  border-right: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;
  vertical-align: middle;
  text-align: center;
}

.modern-equipos-table thead tr.header-group-row th {
  padding: 10px 12px;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.modern-equipos-table thead tr.header-subgroup-row th {
  background: #243042 !important;
  color: #f1f5f9 !important;
  font-weight: 700;
  font-size: 0.73rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 8px 6px;
}

.modern-equipos-table thead tr.header-leaf-row th {
  background: #2a374a !important;
  color: #e2e8f0 !important;
  font-weight: 600;
  font-size: 0.7rem;
  text-transform: uppercase;
  padding: 6px 4px;
  border-bottom: 2px solid #0f172a !important;
}

/* Celdas del cuerpo */
.modern-equipos-table tbody tr.equipos-data-row {
  transition: background-color 0.15s ease;
}

.modern-equipos-table tbody tr.equipos-data-row:nth-child(even) {
  background-color: #f8fafc;
}

.modern-equipos-table tbody tr.equipos-data-row:hover {
  background-color: #f1f5f9;
}

.modern-equipos-table tbody td {
  padding: 5px 10px;
  border-bottom: 1px solid #e2e8f0;
  border-right: 1px solid #edf2f7;
  vertical-align: middle;
}

.modern-equipos-table tbody td.sub-cell-col {
  padding: 0 !important;
}

.sub-items-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
}

.sub-item-cell {
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.76rem;
  padding: 4px;
}

.sub-item-cell:last-child {
  border-bottom: none;
}

/* Badges estilizados */
.tipo-badge {
  background: #f1f5f9;
  color: #334155;
  border: 1px solid #cbd5e1;
  font-size: 0.74rem;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 6px;
  display: inline-block;
  white-space: nowrap;
}

.badge-vehiculo-count {
  background: #f1f5f9;
  color: #1e293b;
  border: 1px solid #cbd5e1;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 4px;
  display: inline-block;
  min-width: 28px;
}

.badge-cant {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 22px;
  height: 20px;
  padding: 0 5px;
  border-radius: 4px;
}

.badge-cant-delantero {
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
}

.badge-cant-posterior {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.badge-cant-libre {
  background: #fefce8;
  color: #a16207;
  border: 1px solid #fef08a;
}

.badge-neumatico-total {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
  font-size: 0.85rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 4px;
  display: inline-block;
  min-width: 32px;
}

/* Fila de Totales */
.modern-equipos-table tfoot tr.table-totals-row {
  background: #f1f5f9 !important;
}

.modern-equipos-table tfoot tr.table-totals-row td {
  padding: 10px !important;
  font-size: 0.82rem;
  border-top: 2px solid #cbd5e1;
  border-bottom: none;
}

/* Recomendaciones UI */
.rec-form-wrapper {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.rec-textarea-input .v-input__slot {
  background-color: #ffffff !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
}

.rec-textarea-input.v-input--is-focused .v-input__slot {
  border-color: #243042 !important;
  box-shadow: 0 0 0 2px rgba(36, 48, 66, 0.1) !important;
}

.rec-save-btn {
  letter-spacing: 0.3px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.rec-save-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(36, 48, 66, 0.25) !important;
}

.rec-table-container {
  border: 1px solid #e2e8f0;
  background: #ffffff;
}

.modern-rec-table {
  width: 100%;
  border-collapse: collapse;
  font-family: inherit;
}

.modern-rec-table thead tr th {
  background: #243042 !important;
  color: #ffffff !important;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 10px 14px;
  border-bottom: 2px solid #0f172a;
}

.modern-rec-table tbody tr.rec-table-row {
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.15s ease;
}

.modern-rec-table tbody tr.rec-table-row:nth-child(even) {
  background-color: #f8fafc;
}

.modern-rec-table tbody tr.rec-table-row:hover {
  background-color: #f1f5f9;
}

.modern-rec-table tbody td {
  padding: 8px 12px;
  vertical-align: middle;
}

.rec-num-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  background: #e2e8f0;
  color: #334155;
  font-weight: 700;
  font-size: 0.78rem;
  border-radius: 50%;
  border: 1px solid #cbd5e1;
}

.rec-row-textarea .v-input__slot {
  background-color: #ffffff !important;
  border-radius: 6px !important;
}

.rec-action-btn {
  transition: transform 0.15s ease;
}

.rec-action-btn:hover {
  transform: scale(1.08);
}

/* ============================================================
   RESPONSIVE: Recomendaciones Técnicas en Móvil (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .rec-toolbar {
    min-height: 48px !important;
    height: auto !important;
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }

  .rec-toolbar-title {
    font-size: 0.88rem !important;
    line-height: 1.2 !important;
  }

  .rec-form-wrapper {
    padding: 12px !important;
    border-radius: 8px !important;
  }

  .rec-form-actions {
    width: 100% !important;
  }

  .rec-save-btn {
    width: 100% !important;
    max-width: 100% !important;
    justify-content: center !important;
  }

  .rec-table-container {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .modern-rec-table,
  .modern-rec-table tbody {
    display: block !important;
    width: 100% !important;
  }

  .modern-rec-table thead {
    display: none !important;
  }

  .modern-rec-table tbody tr.rec-table-row {
    display: flex !important;
    flex-wrap: wrap !important;
    align-items: center !important;
    justify-content: space-between !important;
    background: #ffffff !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 10px !important;
    padding: 10px 12px !important;
    margin-bottom: 12px !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05) !important;
  }

  .modern-rec-table tbody tr.rec-table-row:last-child {
    margin-bottom: 0 !important;
  }

  .modern-rec-table tbody td.rec-cell-num {
    order: 1 !important;
    width: auto !important;
    padding: 0 !important;
    border: none !important;
  }

  .modern-rec-table tbody td.rec-cell-actions {
    order: 2 !important;
    width: auto !important;
    padding: 0 !important;
    border: none !important;
  }

  .modern-rec-table tbody td.rec-cell-desc {
    order: 3 !important;
    width: 100% !important;
    padding: 8px 0 0 0 !important;
    border: none !important;
  }

  .rec-badge-wrapper {
    justify-content: flex-start !important;
  }

  .rec-num-badge {
    width: 26px !important;
    height: 26px !important;
    font-size: 0.78rem !important;
  }

  .rec-action-btn {
    min-width: 36px !important;
    width: 36px !important;
    height: 36px !important;
  }

  .rec-row-textarea {
    font-size: 0.85rem !important;
  }

  .modern-rec-table tbody tr td[colspan="3"] {
    display: block !important;
    width: 100% !important;
    padding: 24px 14px !important;
    border: 1px dashed #cbd5e1 !important;
    border-radius: 10px !important;
    background: #ffffff !important;
  }
}

/* Tabla Resumen de Neumáticos en Mal Estado */
.mal-estado-table-wrapper {
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.modern-mal-estado-table {
  width: 100%;
  border-collapse: collapse;
  font-family: inherit;
  font-size: 0.8rem;
}

.modern-mal-estado-table thead tr th {
  background: #243042 !important;
  color: #ffffff !important;
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 10px 8px;
  border-right: 1px solid #334155;
  border-bottom: 2px solid #0f172a;
  white-space: nowrap;
}

.modern-mal-estado-table thead tr th:last-child {
  border-right: none;
}

.modern-mal-estado-table tbody tr.mal-estado-data-row {
  transition: background-color 0.15s ease;
  border-bottom: 1px solid #e2e8f0;
}

.modern-mal-estado-table tbody tr.mal-estado-data-row:nth-child(even) {
  background-color: #f8fafc;
}

.modern-mal-estado-table tbody tr.mal-estado-data-row:hover {
  background-color: #f1f5f9;
}

.modern-mal-estado-table tbody td {
  padding: 5px 10px;
  border-right: 1px solid #edf2f7;
  vertical-align: middle;
  font-size: 0.78rem;
  color: #334155;
}

.modern-mal-estado-table tbody td:last-child {
  border-right: none;
}

.plate-badge {
  display: inline-block;
  font-family: monospace;
  font-weight: 700;
  font-size: 0.78rem;
  color: #1e293b;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  padding: 2px 7px;
  border-radius: 4px;
  letter-spacing: 0.5px;
}

.pos-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e2e8f0;
  color: #1e293b;
  font-weight: 700;
  font-size: 0.75rem;
  border: 1px solid #cbd5e1;
}

.estado-alert-badge {
  display: inline-block;
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 6px;
  text-transform: uppercase;
  white-space: nowrap;
}

.nsd-badge {
  display: inline-block;
  background: #fffbeb;
  color: #b45309;
  border: 1px solid #fde68a;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
}

.observaciones-cell {
  max-width: 200px;
  line-height: 1.35;
  color: #475569;
}

.img-preview-box {
  display: inline-block;
  position: relative;
}

.mal-estado-img {
  width: 58px;
  height: 58px;
  object-fit: cover;
  border: 1px solid #cbd5e1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.mal-estado-img:hover {
  transform: scale(1.15);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 5;
}

/* Tablas de Reporte Estilo Consolidado */
.table-card-wrapper {
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.modern-report-table {
  width: 100%;
  border-collapse: collapse;
  font-family: inherit;
  font-size: 0.8rem;
}

.modern-report-table thead tr th {
  background: #243042 !important;
  color: #ffffff !important;
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 10px 8px;
  border-right: 1px solid #334155;
  border-bottom: 2px solid #0f172a;
  white-space: nowrap;
}

.modern-report-table thead tr th:last-child {
  border-right: none;
}

.modern-report-table thead tr.header-group-row th {
  padding: 10px 12px;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: #1e293b !important;
}

.modern-report-table thead tr.header-leaf-row th {
  background: #243042 !important;
  font-size: 0.73rem;
}

.modern-report-table tbody tr.report-data-row {
  transition: background-color 0.15s ease;
  border-bottom: 1px solid #e2e8f0;
}

.modern-report-table tbody tr.report-data-row:nth-child(even) {
  background-color: #f8fafc;
}

.modern-report-table tbody tr.report-data-row:hover {
  background-color: #f1f5f9;
}

.modern-report-table tbody td {
  padding: 5px 10px;
  border-right: 1px solid #edf2f7;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: middle;
  font-size: 0.78rem;
  color: #334155;
}

.modern-report-table tbody td:last-child {
  border-right: none;
}

.modern-report-table tfoot tr.table-totals-row {
  background: #f1f5f9 !important;
}

.modern-report-table tfoot tr.table-totals-row td {
  padding: 5px 10px;
  font-size: 0.8rem;
  border-top: 2px solid #cbd5e1;
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: middle;
}

/* Badges compartidos de tablas */
.count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  background: #f1f5f9;
  color: #1e293b;
  border: 1px solid #cbd5e1;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.78rem;
  min-width: 28px;
}

.count-badge-total {
  background: #e2e8f0;
  color: #0f172a;
  border-color: #94a3b8;
  font-size: 0.82rem;
}

.percent-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
}

.percent-badge-total {
  background: #dbeafe;
  color: #1e40af;
  border-color: #93c5fd;
  font-size: 0.8rem;
}

.condition-badge {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #cbd5e1;
  text-transform: uppercase;
}

.inspection-header-bar {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%) !important;
  border-bottom: 2px solid #0f172a;
  padding: 10px 16px !important;
}

.inspection-meta-highlight {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 2px 8px;
  border-radius: 4px;
  font-family: monospace;
}

/* Badges cuadrados para la barra de inspección */
.inspection-badge-square {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 4px;
  padding: 6px 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.inspection-badge-square .badge-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.inspection-badge-square .badge-label {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.75px;
  text-transform: uppercase;
  color: #94a3b8;
  line-height: 1.1;
  margin-bottom: 2px;
}

.inspection-badge-square .badge-value {
  font-size: 0.95rem;
  font-weight: 700;
  color: #f8fafc;
  line-height: 1.2;
}

.inspection-badge-square.highlight-plate {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.3);
}

.inspection-badge-square .plate-value {
  font-family: monospace;
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 1px;
  color: #ffffff;
}

.inspection-badge-square.highlight-date {
  background: rgba(30, 58, 138, 0.4);
  border: 1.5px solid rgba(96, 165, 250, 0.6);
}

.inspection-badge-square .text-blue-light {
  color: #93c5fd !important;
  font-weight: 700;
}

.inspection-badge-square .text-date-value {
  color: #ffffff !important;
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 0.5px;
}

.inspection-badge-square.highlight-km {
  background: rgba(120, 53, 15, 0.45);
  border: 1.5px solid rgba(251, 191, 36, 0.7);
}

.inspection-badge-square .text-amber-light {
  color: #fde68a !important;
  font-weight: 800;
}

.inspection-badge-square .text-km-value {
  color: #fbbf24 !important;
  font-size: 1.2rem;
  font-weight: 900;
  letter-spacing: 0.5px;
  text-shadow: 0 0 10px rgba(251, 191, 36, 0.35);
}

.inspection-badge-square .badge-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
}

.inspection-badge-square .bg-blue-subtle {
  background: rgba(59, 130, 246, 0.25);
  border: 1px solid rgba(96, 165, 250, 0.4);
}

.inspection-badge-square .bg-amber-subtle {
  background: rgba(245, 158, 11, 0.25);
  border: 1px solid rgba(251, 191, 36, 0.45);
}

/* ---- Responsive: badges más compactos en móvil ---- */
@media (max-width: 600px) {
  .inspection-header-bar {
    padding: 8px 12px !important;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .inspection-header-bar > div {
    width: 100%;
    flex-wrap: wrap;
    gap: 6px !important;
  }

  .inspection-badge-square {
    padding: 4px 8px;
    border-radius: 4px;
    flex: 1 1 calc(50% - 6px);
    min-width: 0;
  }

  .inspection-badge-square .badge-label {
    font-size: 0.58rem;
    letter-spacing: 0.5px;
    margin-bottom: 1px;
  }

  .inspection-badge-square .badge-value {
    font-size: 0.8rem;
  }

  .inspection-badge-square .plate-value {
    font-size: 0.88rem;
    letter-spacing: 0.5px;
  }

  .inspection-badge-square .text-date-value {
    font-size: 0.82rem;
    letter-spacing: 0.3px;
  }

  .inspection-badge-square .text-km-value {
    font-size: 0.88rem;
    letter-spacing: 0.3px;
  }

  .inspection-badge-square .badge-icon-box {
    width: 24px;
    height: 24px;
    border-radius: 3px;
    margin-right: 6px !important;
  }

  .inspection-badge-square .badge-icon-box .v-icon {
    font-size: 14px !important;
  }
}

/* Overlay y Card de carga para la consulta */
.v-overlay--active.consulta-overlay-container {
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.consulta-loader-card {
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 20px 35px -5px rgba(0, 0, 0, 0.25),
    0 10px 15px -5px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  padding: 32px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 320px;
  max-width: 440px;
  text-align: center;
  animation: fadeInScale 0.25s ease-out;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.94);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.consulta-loader-spinner-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.consulta-loader-inner-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta-loader-title {
  font-size: 1.1rem;
  color: #1e293b;
  letter-spacing: -0.2px;
}

.consulta-loader-subtitle {
  font-size: 0.84rem;
  color: #64748b;
  line-height: 1.4;
}

.consulta-loader-status-bar {
  width: 100%;
  max-width: 220px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
